<template>
    <section class="heightContainer">
        <b-overlay :show="loading" no-wrap opacity="1">
        </b-overlay>
        <section class="rtaTitle">
            <button class="btn-back" @click="goBack" title="Voltar para lista">
                <i class="fa fa-arrow-left"></i>
            </button>
            <img :src="require('@/assets/rta/detailsRta.svg')" alt="Details RTA" />
            <span>Detalhamento da RTA</span>
        </section>
        <section class="rtaDetailsContainer">
            <section class="generalInfo" v-show="showDetailsInfo">
                <CustomInputRta type="text" class="code" id="code" :modelRef="detailsRta.code" :editable="false"
                    title="Gerado pelo Sistema" label="Código RTA" :inputFunc="event => {
                        this.detailsRta.code = event.target.value
                    }" />

                <CustomInputRta type="select" class="ind" id="indicator" :modelRef="detailsRta.indicatorId"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Indicador *" :inputFunc="event => {
                        this.detailsRta.indicatorId = Number(event.target.value)
                    }" :optList="this.allIndicators" optValue="id" optDisplay="indicatorName" />

                <CustomInputRta type="select" class="proc" id="proc" :modelRef="detailsRta.processId"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Processo *" :optList="this.process" optValue="id" optDisplay="description" :inputFunc="event => {
                        this.detailsRta.processId = Number(event.target.value)
                    }" />

                <CustomInputRta type="select" class="prod" id="prod" :modelRef="detailsRta.productId"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Produto" :optList="products" optValue="id" optDisplay="description" :inputFunc="event => {
                        this.detailsRta.productId = Number(event.target.value)
                    }" />

                <CustomInputRta type="select" class="resp" id="resp" :modelRef="detailsRta.mainRespId"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Responsável *" :optList="usersResps" optValue="id" optDisplay="name" :inputFunc="event => {
                        this.detailsRta.mainRespId = Number(event.target.value)
                    }" />

                <div class="auxResp">
                    <span>Participantes do Tratamento</span>
                    <button
                        v-if="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                        class="btn-add-participant"
                        @click="openAddParticipantModal"
                        type="button"
                        title="Adicionar Participante">
                        <i class="fa fa-plus"></i>
                    </button>
                    <div
                        v-if="this.detailsRta.auxResponsibles && this.detailsRta.auxResponsibles.length > 0"
                        class="participants-list">
                        <div v-for="(aux, auxIdx) in this.detailsRta.auxResponsibles" :key="auxIdx" class="participant-item">
                            <p>{{ aux.UserName }}</p>
                            <button
                                v-if="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                                class="btn-remove-participant"
                                @click="removeParticipant(aux.UserId)"
                                type="button"
                                title="Remover Participante">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <CustomInputRta type="date" class="creation" id="creation" :modelRef="detailsRta.formattedCreationDate"
                    :editable="isManual && detailsRta.id === -9999"
                    label="Data de Abertura *" :inputFunc="event => {
                        this.detailsRta.formattedCreationDate = event.target.value
                    }" />

                <CustomInputRta type="text" class="stopNote" id="stopNote" :modelRef="detailsRta.stopNote"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Nota de Parada" :inputFunc="event => {
                        this.detailsRta.stopNote = event.target.value
                    }" />

                <CustomInputRta type="date" class="deadline" id="deadline" :modelRef="detailsRta.formattedDeadline"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Prazo *" :inputFunc="event => {
                        this.detailsRta.formattedDeadline = event.target.value;
                        this.deadlineModified = true;
                    }" />

                <CustomInputRta type="select" class="equip" id="equip" :modelRef="detailsRta.equipmentId"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Equipamento" :optList="equipment" optValue="id" optDisplay="description" :inputFunc="event => {
                        this.detailsRta.equipmentId = Number(event.target.value)
                    }" />

                <CustomInputRta type="text" class="trigger" id="trigger" :modelRef="detailsRta.trigger"
                    :editable="false" label="Gatilho" :inputFunc="event => {
                        this.detailsRta.trigger = event.target.value
                    }" />

                <CustomInputRta type="select" class="accResp" id="accResp" :modelRef="detailsRta.efficiencyRespId"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Resp. Eficácia *" :optList="usersResps" optValue="id" optDisplay="name" :inputFunc="event => {
                        this.detailsRta.efficiencyRespId = Number(event.target.value)
                    }" />
            </section>

            <section class="openFcas">
                <b-form-textarea rows="1" no-resize :v-model="detailsRta.desc" :value="detailsRta.desc"
                    id="textares-rta" @input="text => detailsRta.desc = text">
                </b-form-textarea>

                <div class="buttons-container">
                    <button
                        v-if="detailsRta.triggerId !== 11"
                        class="btn-view-linked-fcas"
                        @click="openLinkedOccurrencesModal">Visualizar FCAs de Ind. Vinculados
                    </button>

                    <button v-if="displaySecondaryTriggers.length > 0"
                        @click="() => this.$bvModal.show('secondaryTriggersModal')" class="LinkedTriggersButton">
                        Gatilhos Vinculados ({{ displaySecondaryTriggers.length }})
                    </button>
                </div>
            </section>

            <button @click="toggleDetailsInfo" class="showDetailsBtn">
                <span>Ocultar Detalhes</span>
                <b-icon-chevron-expand />
            </button>

            <section class="dealSection">
                <b-tabs content-class="customTabsClassContainerRta" class="customTabsClassRta">
                    <b-tab title="Identificação de Causa Raiz" active>
                        <section class="respContainer">
                            <CustomInputRta type="text" id="effectReason" :modelRef="reasonDetails.effect"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Efeito/Anomalia" :blue-class="true" :inputFunc="event => {
                                    this.reasonDetails.effect = event.target.value
                                }" />

                            <CustomInputRta type="select" id="respReason" :modelRef="reasonDetails.respAnalysisId"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Resp. Análise *" :blue-class="true" :optList="usersResps" optValue="id"
                                optDisplay="name" :inputFunc="event => {
                                    this.reasonDetails.respAnalysisId = Number(event.target.value)
                                }" />

                            <CustomInputRta type="text" id="respReasonRole" :modelRef="reasonDetails.respRole"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Cargo do Responsável" :blue-class="true" :inputFunc="event => {
                                    this.reasonDetails.respRole = event.target.value
                                }" />

                            <CustomInputRta type="date" id="respReasonDate" :modelRef="reasonDetails.analysisDate"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Data da Análise" :blue-class="true" :inputFunc="event => {
                                    this.reasonDetails.analysisDate = event.target.value
                                }" />
                        </section>
                        <section class="methodsAllowed">
                            <b-tabs pills no-nav-style content-class="customTabsReasonContent"
                                class="customTabsReasonContainer">
                                <b-tab v-if="analysisType == 0 || analysisType == 2" title="6Ms de Ishikawa" active>
                                    <div :style="{ height: `${reasonTableHeight}px` }">
                                        <DealRtaTable :headers="ishikawaCols" :data="ishikawaData"
                                            :height="reasonTableHeight" @toDeleteItem="getLineToDelete" type="ishik"
                                            :show-action-acc="avaliateEfficActionType" :userPermission="pagePermissions"
                                            :efficFunc="handleEfficDeal" :respList="usersResps"
                                            :readonly="disableEdit"
                                            @mainCauseBlur="onMainCauseBlur" />
                                    </div>
                                    <button v-if="!disableEdit" @click="addReasonLine(0)" class="addLineTable">
                                        <b-icon-plus-circle-fill />
                                        <span>Adicionar Linha</span>
                                    </button>
                                </b-tab>
                                <b-tab v-if="analysisType == 0 || analysisType == 1" title="5 Porquês">
                                    <div :style="{ height: `${reasonTableHeight}px` }">
                                        <DealRtaTable :headers="porquesCols" :data="porquesData"
                                            :height="reasonTableHeight" @toDeleteItem="getLineToDelete" type="5pq"
                                            :show-action-acc="avaliateEfficActionType" :userPermission="pagePermissions"
                                            :efficFunc="handleEfficDeal" :respList="usersResps"
                                            :readonly="disableEdit"
                                            :origin-list="originOptions"
                                            :manage-origin-func="disableEdit ? null : openOriginManager"
                                            @mainCauseBlur="onMainCauseBlur" />
                                    </div>
                                    <button v-if="!disableEdit" @click="addReasonLine(1)" class="addLineTable">
                                        <b-icon-plus-circle-fill />
                                        <span>Adicionar Linha</span>
                                    </button>
                                </b-tab>
                            </b-tabs>
                        </section>

                    </b-tab>
                    <b-tab title="Elaboração do Plano de Ação">
                        <section class="respContainer">
                            <CustomInputRta type="select" id="actionResp" :modelRef="actionDetails.respActionId"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Resp. pelo Plano *" :blue-class="true" :optList="usersResps" optValue="id"
                                optDisplay="name" :inputFunc="event => {
                                    this.actionDetails.respActionId = Number(event.target.value)
                                }" />

                            <CustomInputRta type="text" id="actionRespRole" :modelRef="actionDetails.respActionRole"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Cargo do Responsável" :blue-class="true" :inputFunc="event => {
                                    this.actionDetails.respActionRole = event.target.value
                                }" />

                            <CustomInputRta type="date" id="actionDate" :modelRef="actionDetails.actionDate"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Data da Elaboração do Plano" :blue-class="true" :inputFunc="event => {
                                    this.actionDetails.actionDate = event.target.value
                                }" />
                        </section>
                        <div :style="{ height: `${actionTableHeight}px` }">
                            <DealRtaTable :headers="actionPlanCols" :data="actionPlanData" :height="actionTableHeight"
                                @toDeleteItem="getLineToDelete" type="actions"
                                :show-action-acc="avaliateEfficActionType" :userPermission="pagePermissions"
                                :efficFunc="handleEfficDeal" :respList="usersResps"
                                :updateStatusFunc="calculateActionStatus" :processList="process"
                                :readonly="disableEdit"
                                :mainCauseList="mainCauseOptions" />
                        </div>
                        <button v-if="!disableEdit" @click="addActionLine" class="addLineTable">
                            <b-icon-plus-circle-fill />
                            <span>Adicionar Linha</span>
                        </button>
                    </b-tab>
                </b-tabs>
            </section>

            <section class="rtaBtnContainer">
                <div>
                    <button v-if="disableEdit == false && pagePermissions.canCancel && !pagePermissions.isManual"
                        class="cancelBtn" @click="() => handleSave(7)">
                        <b-icon-trash-fill />
                        <span>Cancelar RTA</span>
                    </button>
                    <button v-if="false" class="reopenBtn">
                        <b-icon-reply-fill />
                        <span>Reabrir RTA</span>
                    </button>
                </div>
                <div>
                    <div v-if="pagePermissions.isActionReasonResp && disableEdit == false" class="attachment-btn-container">
                        <AttachmentManager
                            :files="reasonAttachments.files"
                            :links="reasonAttachments.links"
                            :editable="true"
                            @change="handleReasonAttachmentsChange"
                            buttonText="Anexar Arquivos"
                        />
                    </div>
                    <button v-if="avaliateEfficActionType == 1 && pagePermissions.canAvaliate" class="accBtn">
                        <span>Avaliar Plano de Ação</span>
                    </button>
                    <button v-if="pagePermissions.canAvaliate" class="accBtn"
                        @click="() => handleEfficDeal('rta', detailsRta.id)">
                        <span>{{ rtaWasEvaluated ? 'RTA Avaliada' : 'Avaliar RTA' }}</span>
                    </button>
                    <button v-if="pagePermissions.canFinish && disableEdit == false" class="doneBtn"
                        :disabled="rtaWasConcluded"
                        @click="!rtaWasConcluded && handleSave(6)">
                        <b-icon-check-circle-fill />
                        <span>{{ rtaWasConcluded ? 'RTA Concluída' : 'Concluir RTA' }}</span>
                    </button>
                    <button v-if="disableEdit == false" class="saveBtn" @click="onSaveClick">
                        <img :src="require('@/assets/rta/save-svg.svg')" alt="Save RTA" />
                        <span>Salvar</span>
                    </button>
                </div>
            </section>
        </section>
        <b-modal id="fcaViewModal" size="xl" hide-footer>
            <div slot="modal-title" class="img-slot">
                <img style="width: 33px; height: 33px; margin-right: 10px" src="@/assets/circular138.png"
                    alt="occurrence_icon" />
                <label>Visualizar FCAs de Indicadores Vinculados</label>
            </div>

            <div v-if="loadingLinkedOccurrences" style="text-align: center; padding: 50px;">
                <b-spinner variant="dark"></b-spinner>
                <p>Carregando ocorrências...</p>
            </div>

            <div v-else-if="linkedIndicatorInfo && linkedIndicatorInfo.id && linkedOccurrences.length > 0">
                <ManageAllOccurrences
                    :indicatorInfo="linkedIndicatorInfo"
                    :occurrenceInfo="linkedOccurrences[0]"
                    :otherOccurrencesInfo="linkedOccurrences"
                    :showActionResponsible="false"
                    :viewMode="'rta-linked'"
                    :linkedIndicatorsList="linkedIndicatorsList"
                    :reloadOccFunct="reloadLinkedOccurrences"
                    @filter-by-indicator="filterLinkedOccurrences">
                </ManageAllOccurrences>
            </div>

            <div v-else style="padding: 20px; text-align: center; color: #666;">
                Nenhum dado disponível para exibição.
            </div>

            <div v-if="!loadingLinkedOccurrences && linkedOccurrences.length == 0" style="padding: 20px; text-align: center;">
                Nenhuma ocorrência encontrada para os indicadores vinculados no período.
            </div>
        </b-modal>

        <b-modal id="secondaryTriggersModal" size="xl" hide-footer title="Gatilhos Vinculados">
            <p class="mb-3">
                <strong>{{ displaySecondaryTriggers.length }}</strong> gatilho(s) secundário(s) vinculado(s) a esta RTA:
            </p>
            <b-table
                v-if="displaySecondaryTriggers.length > 0"
                :items="displaySecondaryTriggers"
                :fields="secondaryTriggersFields"
                striped
                hover
                responsive
                small
                class="secondary-triggers-table">
            </b-table>
            <div class="mt-3 d-flex justify-content-end">
                <b-button variant="secondary" @click="$bvModal.hide('secondaryTriggersModal')">
                    Fechar
                </b-button>
            </div>
        </b-modal>

        <b-modal id="rtaGeneralEfficModal" size="xl" hide-footer title="Avaliação de Eficácia">
            <EfficiencyForm :evidence-is-required="!disableAttachmentRequirement" :resp-list="usersResps" :detailsRta="detailsRta"
                :efficrelatedid="effitCRelatedId" :effitCtype="effitCtype" @saved="onEfficSaved" />
        </b-modal>


        <b-modal id="rtaDealDelete" title="Remover Linha" hide-footer>
            <p>Deseja realmente excluir essa linha?</p>
            <p>Lembrando que, caso queira reverter a exclusão, basta não clicar no
                botão "Salvar".</p>
            <RtaModalButtons :cancel-func="() => this.$bvModal.hide('rtaDealDelete')" :ok-func="handleDeleteLine" />
        </b-modal>

        <b-modal id="confirmSaveNewRtaModal" title="Confirmar Criação de RTA" hide-footer>
            <p>Deseja realmente criar esta nova RTA?</p>
            <p class="warning-text">Atenção: Depois de salva, esta ação é irreversível.</p>
            <div class="modal-buttons-spread">
                <button class="cancel-btn" @click="$bvModal.hide('confirmSaveNewRtaModal')">Cancelar</button>
                <button class="confirm-btn" @click="confirmSaveNewRta">Confirmar</button>
            </div>
        </b-modal>

        <b-modal id="addParticipantModal" title="Adicionar Participantes" hide-footer size="md">
            <div class="add-participant-content">
                <CustomInputRta
                    type="select"
                    id="participantSelect"
                    :modelRef="selectedParticipantId"
                    :editable="true"
                    label="Selecionar Usuário"
                    :blue-class="true"
                    :optList="availableUsers"
                    optValue="id"
                    optDisplay="name"
                    :inputFunc="event => {
                        selectedParticipantId = Number(event.target.value)
                    }" />

                <button
                    class="btn-add-to-list"
                    @click="addParticipantToList"
                    :disabled="!selectedParticipantId">
                    <i class="fa fa-plus"></i>
                    Adicionar à Lista
                </button>

                <div v-if="tempParticipants.length > 0" class="temp-participants-list">
                    <h6>Participantes a adicionar:</h6>
                    <div v-for="(participant, idx) in tempParticipants" :key="idx" class="temp-participant-item">
                        <span>{{ participant.UserName }}</span>
                        <button
                            class="btn-remove-temp"
                            @click="removeTempParticipant(idx)"
                            type="button">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="modal-footer-custom">
                <button class="btn-cancel-modal" @click="cancelAddParticipants">Cancelar</button>
                <button
                    class="btn-confirm-modal"
                    @click="confirmAddParticipants"
                    :disabled="tempParticipants.length === 0">
                    Confirmar
                </button>
            </div>
        </b-modal>

        <!-- ===== MODAL: GERENCIADOR DE ORIGENS ===== -->
        <b-modal
            id="modalOriginManager"
            title="Gerenciar: Origens"
            hide-footer
            size="md"
        >
            <b-overlay :show="savingOrigins" rounded="sm" opacity="0.6">
                <div class="domain-search-row">
                    <input
                        type="text"
                        v-model="originSearchQuery"
                        class="sru-input domain-input"
                        placeholder="Pesquisar..."
                        autocomplete="off"
                    />
                </div>

                <div class="domain-scroll-area">
                    <template v-if="hasMatchingOriginPresets">
                        <div class="group-header" @click="originPresetsCollapsed = !originPresetsCollapsed">
                            <span>Origens Padrão</span>
                            <b-icon-chevron-up v-if="!originPresetsCollapsed" />
                            <b-icon-chevron-down v-if="originPresetsCollapsed" />
                        </div>
                        <transition name="accordion">
                        <div v-show="!originPresetsCollapsed" class="domain-presets-section">
                            <div
                                v-for="p in originPresets"
                                :key="'preset-' + p.value"
                                v-show="!originSearchQuery || p.value.toLowerCase().includes(originSearchQuery.toLowerCase())"
                                class="domain-list-item domain-list-item--preset"
                            >
                                <input type="text" :value="p.value" disabled class="sru-input domain-input" />
                            </div>
                        </div>
                        </transition>
                    </template>

                    <template v-if="hasMatchingOriginCustoms">
                        <div class="group-header" @click="originCustomsCollapsed = !originCustomsCollapsed">
                            <span>Itens Adicionados (Outros)</span>
                            <b-icon-chevron-up v-if="!originCustomsCollapsed" />
                            <b-icon-chevron-down v-if="originCustomsCollapsed" />
                        </div>
                    <transition name="accordion">
                    <div v-show="!originCustomsCollapsed" class="domain-list">
                        <div
                            v-for="(item, idx) in editingOriginItems"
                            :key="idx"
                            v-show="!originSearchQuery || item.value.toLowerCase().includes(originSearchQuery.toLowerCase())"
                            class="domain-list-item"
                        >
                            <input
                                type="text"
                                v-model="editingOriginItems[idx].value"
                                class="sru-input domain-input"
                            />
                            <button class="btn-delete-domain" @click="deleteOriginItem(item)" title="Remover opção">
                                <svg viewBox="0 0 24 24" style="width:14px;fill:currentColor"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
                            </button>
                        </div>
                    </div>
                    </transition>
                    </template>
                </div>

                <div class="domain-add-row">
                    <input
                        type="text"
                        v-model="newOriginValue"
                        class="sru-input domain-input"
                        placeholder="Novo item..."
                        @keyup.enter="addOriginItem"
                    />
                    <button class="btn-add-domain" @click="addOriginItem">+</button>
                </div>

                <div class="domain-footer">
                    <button class="btn-save-domain" @click="saveOriginDomains" :disabled="savingOrigins">
                        <span v-if="savingOrigins" class="spinner-border spinner-border-sm mr-1"></span>
                        Salvar
                    </button>
                    <button class="btn-cancel-domain" @click="$bvModal.hide('modalOriginManager')" :disabled="savingOrigins">Cancelar</button>
                </div>
            </b-overlay>
        </b-modal>
    </section>
</template>

<script>
import CustomInputRta from './commons/CustomInputRta.vue';
import DealRtaTable from './commons/DealRtaTable.vue';
import EfficiencyForm from './commons/EfficiencyForm.vue';
import RtaModalButtons from './commons/RtaModalButtons.vue';
import AttachmentManager from './commons/AttachmentManager.vue';
import ManageAllOccurrences from '../manageAllOccurrences/ManageAllOccurrences.vue';
import axios from '../../../node_modules/axios/index';
import { urlMainAPI, defaultSuccess, showError } from '../../global';
import * as moment from 'moment';
import { mapState } from "vuex";
import { v4 as uuidv4 } from 'uuid';
import JSZip from 'jszip';
export default {
    name: "RTADetails",
    components: { CustomInputRta, DealRtaTable, EfficiencyForm, RtaModalButtons, AttachmentManager, ManageAllOccurrences },
    computed: {
        ...mapState(["user"]),

        mainCauseOptions() {
            const seen = new Set();
            const items = [];
            const styleByOrigin = {
                "6Ms":  { bg: "#e3f0ff", color: "#1f5b9b", title: "Origem: 6Ms de Ishikawa" },
                "5Pqs": { bg: "#fff1e0", color: "#a05a17", title: "Origem: 5 Porquês" }
            };
            const push = (text, origin) => {
                const t = (text || "").toString().trim();
                if (!t) return;
                const key = t + "|" + origin;
                if (seen.has(key)) return;
                seen.add(key);
                const s = styleByOrigin[origin] || { bg: "#eee", color: "#333", title: "" };
                items.push({ value: t, label: t, origin, badgeBg: s.bg, badgeColor: s.color, badgeTitle: s.title });
            };
            this.ishikawaData.forEach(r => push(r.mainCause, "6Ms"));
            this.porquesData.forEach(r  => push(r.mainCause, "5Pqs"));
            return items;
        },

        hasMatchingOriginPresets() {
            if (!this.originSearchQuery) return true;
            const q = this.originSearchQuery.toLowerCase();
            return this.originPresets.some(p => p.value.toLowerCase().includes(q));
        },

        hasMatchingOriginCustoms() {
            if (!this.editingOriginItems.length) return false;
            if (!this.originSearchQuery) return true;
            const q = this.originSearchQuery.toLowerCase();
            return this.editingOriginItems.some(i => i.value.toLowerCase().includes(q));
        },
        allFinishedActionsEvaluated() {
            // Verifica se todas as ações com término real foram avaliadas
            const finishedActions = this.actionPlanData.filter(ac =>
                ac.actionStatus === "completed" ||
                ac.actionStatus === "completed-late" ||
                ac.actionStatus === "evaluation-pending"
            );
            if (finishedActions.length === 0) return true;
            return finishedActions.every(ac => ac.evaluationData != null);
        },
        availableUsers() {
            /**
             * Lista de usuários disponíveis para adicionar
             *
             * Exclui apenas:
             * - Usuários que JÁ estão no auxResponsibles
             * - Usuários na lista temporária
             *
             * PODE adicionar os 4 responsáveis de volta se foram removidos!
             */
            const currentParticipantIds = (this.detailsRta.auxResponsibles || []).map(p => p.UserId);
            const tempParticipantIds = this.tempParticipants.map(p => p.UserId);
            const allExcludedIds = [...currentParticipantIds, ...tempParticipantIds];

            return this.usersResps.filter(user => !allExcludedIds.includes(user.id));
        },
        secondaryTriggersFields() {
            return [
                { key: 'triggerId', label: 'Código do Gatilho', sortable: true, thStyle: { width: '9%' } },
                { key: 'creationDate', label: 'Data de Disparo', sortable: true, thStyle: { width: '11%' } },
                { key: 'indicator', label: 'Indicador', sortable: true, thStyle: { width: '11%' } },
                { key: 'process', label: 'Processo', sortable: true, thStyle: { width: '11%' } },
                { key: 'workshift', label: 'Turno', sortable: true, thStyle: { width: '7%' } },
                { key: 'trigger', label: 'Gatilho', sortable: true, thStyle: { width: '10%' } },
                { key: 'lowerLimit', label: 'Limite Inferior', sortable: true, thStyle: { width: '9%' }, formatter: value => value != null ? Number(value).toFixed(2) : '-' },
                { key: 'upperLimit', label: 'Limite Superior', sortable: true, thStyle: { width: '9%' }, formatter: value => value != null ? Number(value).toFixed(2) : '-' },
                { key: 'realValue', label: 'Realizado', sortable: true, thStyle: { width: '9%' }, formatter: value => value != null ? Number(value).toFixed(2) : '-' },
                { key: 'responsible', label: 'Responsável', sortable: true, thStyle: { width: '14%' } },
            ];
        },
        // Filtra gatilhos para exibição (exclui o principal, que já está nos dados da RTA)
        displaySecondaryTriggers() {
            return this.secondaryTriggers.filter(t => !t.isMain);
        },
        originOptions() {
            const presetItems = this.originPresets.map(p => ({ label: p.value, value: p.value }));
            const customItems = this.originCustomItems.map(c => ({ label: c.value, value: c.value }));
            return [...presetItems, ...customItems];
        },
    },
    watch: {
        actionPlanData: {
            handler() {
                // Recalcula o status de todas as ações sempre que qualquer mudança ocorrer
                if (this.actionPlanData && this.actionPlanData.length > 0) {
                    this.updateAllActionStatuses();
                }
            },
            deep: true
        },
    },
    props: ["isManual"],
    data() {
        return {
            validatingActions: false,
            actionValidated: {},
            loadedHasReason: false,
            loadedHasActions: false,
            loading: false,
            rtaWasEvaluated: false,
            rtaWasConcluded: false,
            rtaRatingOff: false,
            lineToDelete: null,
            showDetailsInfo: true,
            actionTableHeight: 140,
            reasonTableHeight: 120,
            relatedIndicators: [],
            relatedSelected: null,
            occurrenceStructureMock: {},
            linkedOccurrences: [],
            allLinkedOccurrences: [],
            linkedIndicatorsList: [],
            loadingLinkedOccurrences: false,
            linkedIndicatorInfo: {},
            selectedParticipantId: null,
            tempParticipants: [],
            participantsInitialized: false,
            secondaryTriggers: [],
            pagePermissions: {
                isManualRta: false,
                isMainResp: false,
                isAuxResp: false,
                isActionReasonResp: false,
                canFinish: false,
                canAvaliate: false,
                canCancel: false,
            },
            effitCtype: null,
            effitCRelatedId: null,
            disableEdit: false,
            usersResps: [],
            process: [],
            products: [],
            equipment: [],
            allIndicators: [],
            avaliateEfficActionType: 0,
            analysisType: 0,
            disableAttachmentRequirement: false,
            rtaUseMaxDeadline: false,
            rtaMaxDeadlineDays: null,
            deadlineModified: false,
            detailsRta: {
                code: "",
                indicatorName: "",
                processId: null,
                productId: null,
                equipmentId: null,
                mainRespId: null,
                creationDate: "",
                deadline: "",
                triggerName: "",
                efficiencyRespId: null,
                auxResps: [],
                generalResponsibles: "",
                desc: "",
            },

            reasonDetails: {
                effect: "",
                respAnalysisId: null,
                respRole: "",
                analysisDate: ""
            },

            reasonAttachments: {
                files: [],
                links: []
            },
            reasonAttachmentFileId: null,

            actionDetails: {
                respActionId: null,
                respActionRole: "",
                actionDate: ""
            },

            actionPlanCols: [
                { field: "mainReason", key: "mainReason", title: "Causa Fundamental", align: "center", edit: true, width: 130, ellipsis: { lineClamp: 2 }, required: true },
                { field: "what", key: "what", title: "O Que (Ação)", align: "center", edit: true, width: 130, ellipsis: { lineClamp: 2 } },
                { field: "how", key: "how", title: "Como (Etapa)", align: "center", edit: true, width: 130, ellipsis: { lineClamp: 2 } },
                { field: "where", key: "where", title: "Onde (Processo)", align: "center", edit: true, width: 130, ellipsis: { lineClamp: 2 } },
                { field: "howMuch", key: "howMuch", title: "Quanto", align: "center", edit: true, width: 100, ellipsis: { lineClamp: 2 } },
                { field: "who", key: "who", title: "Responsável", align: "center", edit: false, width: 130, ellipsis: { lineClamp: 1 } },
                { field: "whenInitPrev", key: "whenInitPrev", title: "Início Previsto*", align: "center", width: 110, edit: false, ellipsis: { lineClamp: 1 } },
                { field: "whenFinishPrev", key: "whenFinishPrev", title: "Término Previsto*", align: "center", width: 110, edit: false, ellipsis: { lineClamp: 1 } },
                { field: "whenInitReal", key: "whenInitReal", title: "Início Real", align: "center", width: 110, edit: false, ellipsis: { lineClamp: 1 } },
                { field: "whenFinishReal", key: "whenFinishReal", title: "Término Real", align: "center", width: 110, edit: false, ellipsis: { lineClamp: 1 } },
                { field: "actionType", key: "actionType", title: "Tipo", align: "center", edit: false, width: 90, ellipsis: { lineClamp: 1 } },
                { field: "actionStatus", key: "actionStatus", title: "Status", align: "center", edit: false, width: 180 },
                { field: "actionAcc", key: "actionAcc", title: "Eficácia", align: "center", edit: false, width: 100, ellipsis: { lineClamp: 1 } },
                { field: "actionDelete", key: "actionDelete", title: "Remover", align: "center", width: 80, edit: false, ellipsis: { lineClamp: 1 } },
            ],
            actionPlanData: [],

            ishikawaCols: [
                { field: "sixm", key: "sixm", title: "6Ms", align: "center", edit: false, width: 130, ellipsis: { lineClamp: 1 } },
                { field: "firstCause", key: "firstCause", title: "Causa Primária", align: "center", edit: true, width: 160, ellipsis: { lineClamp: 2 } },
                { field: "secondCause", key: "secondCause", title: "Causa Secundária", align: "center", edit: true, width: 160, ellipsis: { lineClamp: 2 } },
                { field: "thirdCause", key: "thirdCause", title: "Causa Terciária", align: "center", edit: true, width: 160, ellipsis: { lineClamp: 2 } },
                { field: "fourthCause", key: "fourthCause", title: "Causa Quaternária", align: "center", edit: true, width: 160, ellipsis: { lineClamp: 2 } },
                { field: "fifthCause", key: "fifthCause", title: "Causa Quintenária", align: "center", edit: true, width: 160, ellipsis: { lineClamp: 2 } },
                { field: "sixthCause", key: "sixthCause", title: "Causa Sextenária", align: "center", edit: true, width: 160, ellipsis: { lineClamp: 2 } },
                { field: "mainCause", key: "mainCause", title: "Causa Fundamental", align: "center", edit: true, width: 180, ellipsis: { lineClamp: 2 }, required: true },
                { field: "actionDelete", key: "actionDelete", title: "Remover", align: "center", edit: false, width: 80, ellipsis: { lineClamp: 1 } },
            ],
            ishikawaData: [],

            porquesCols: [
                { field: "firstPq", key: "firstPq", title: "Primeiro Porquê", align: "center", edit: true, width: 160, ellipsis: { lineClamp: 2 } },
                { field: "secondPq", key: "secondPq", title: "Segundo Porquê", align: "center", edit: true, width: 160, ellipsis: { lineClamp: 2 } },
                { field: "thirdPq", key: "thirdPq", title: "Terceiro Porquê", align: "center", edit: true, width: 160, ellipsis: { lineClamp: 2 } },
                { field: "fourthPq", key: "fourthPq", title: "Quarto Porquê", align: "center", edit: true, width: 160, ellipsis: { lineClamp: 2 } },
                { field: "fifthPq", key: "fifthPq", title: "Quinto Porquê", align: "center", edit: true, width: 160, ellipsis: { lineClamp: 2 } },
                { field: "mainCause", key: "mainCause", title: "Causa Fundamental", align: "center", edit: true, width: 180, ellipsis: { lineClamp: 2 }, required: true },
                { field: "origin", key: "origin", title: "Origem", align: "center", edit: false, width: 130, ellipsis: { lineClamp: 2 } },
                { field: "actionDelete", key: "actionDelete", title: "Remover", align: "center", edit: false, width: 80, ellipsis: { lineClamp: 1 } },
            ],
            porquesData: [],

            // Origin manager
            originCustomItems: [],
            savingOrigins: false,
            originPresets: [
                { value: "Mecânica" },
                { value: "Elétrica" },
                { value: "Instrumentação" },
                { value: "Operacional" },
                { value: "Matéria Prima" },
            ],
            editingOriginItems: [],
            deletedOriginIds: [],
            newOriginValue: "",
            originSearchQuery: "",
            originPresetsCollapsed: true,
            originCustomsCollapsed: true,
        }
    },
    methods: {
        calculateActionStatus(action) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const parse = d => d ? new Date(d + 'T00:00:00') : null;

            const finishPrev = parse(action.whenFinishPrev);
            const initReal   = parse(action.whenInitReal);
            const finishReal = parse(action.whenFinishReal);

            // 1. Tem avaliação → Concluído (com ou sem atraso)
            if (action.evaluationData) {
                return (finishReal && finishPrev && finishReal > finishPrev)
                    ? "completed-late"
                    : "completed";
            }

            // 2. Término real preenchido mas sem avaliação
            if (finishReal) {
                if (this.avaliateEfficActionType !== 0) {
                    return (finishPrev && finishReal > finishPrev) ? "completed-late" : "completed";
                }
                return "evaluation-pending";
            }

            // 3. Lógica original (Não Iniciado, Em Atraso, Em Andamento)
            if (!initReal || initReal > today) {
                if (finishPrev && today > finishPrev) return "delayed";
                return "not-started";
            }

            if (finishPrev) {
                if (initReal > finishPrev) return "delayed";
                if (today > finishPrev) return "delayed";
            }

            return "in-progress";
        },

        updateAllActionStatuses() {
            this.actionPlanData.forEach(action => {
                action.actionStatus = this.calculateActionStatus(action);
            });
        },

        generateAutomaticDescription(rta) {
            let desc = `No dia ${moment(rta.desvioDate || rta.creationDate).format("DD/MM/YYYY")} o Indicador ${rta.indicator} referente ao processo ${rta.process}`;

            if (rta.equipment && rta.equipment !== "-" && rta.equipment.trim() !== "") {
                desc += `, equipamento ${rta.equipment}`;
            }

            if (rta.product && rta.product !== "-" && rta.product.trim() !== "") {
                desc += `, produto ${rta.product}`;
            }

            let lowerLimit = "-";
            let upperLimit = "-";

            const indicator = this.allIndicators.find(ind => ind.id === rta.indicatorId);

            if (indicator && indicator.indicatorRule && indicator.indicatorRule.trim() !== "" && indicator.indicatorRule.trim() !== "-" &&
                rta.target && rta.target !== null && rta.target !== "" && rta.target !== -9999) {

                const ruleParts = indicator.indicatorRule.split(" ");
                const signal = ruleParts[0]; // '>', '<', ou '='
                const criticalRange = ruleParts[2]; // Porcentagem de variação

                if (!isNaN(criticalRange.replace(",", "."))) {
                    const percentageValue = (Number(rta.target) * Number(criticalRange.replace(",", "."))) / 100;

                    lowerLimit = (Math.floor((Number(rta.target) - percentageValue) * 100) / 100).toFixed(2);
                    upperLimit = (Math.floor((Number(rta.target) + percentageValue) * 100) / 100).toFixed(2);

                    if (signal.trim() === ">") {
                        lowerLimit = "-"; // Apenas limite superior
                    } else if (signal.trim() === "<") {
                        upperLimit = "-"; // Apenas limite inferior
                    }
                    }
            }

            let formattedValue = rta.value;
            if (rta.value && !isNaN(rta.value)) {
                const numValue = Number(rta.value);
                if (numValue >= 1) {
                    formattedValue = numValue.toFixed(2); // 2 casas decimais para valores >= 1
                } else {
                    formattedValue = numValue.toFixed(3); // 3 casas decimais para valores < 1
                }
            }

            let formattedTarget = "-";
            if (rta.target && !isNaN(rta.target)) {
                const numTarget = Number(rta.target);
                formattedTarget = numTarget >= 1 ? numTarget.toFixed(2) : numTarget.toFixed(3);
            }

            desc += ` com LIE de ${lowerLimit}, LSE ${upperLimit}, Previsto ${formattedTarget} e Realizado ${formattedValue}`;
            desc += `, gerou uma RTA pelo gatilho ${rta.originalTrigger || rta.trigger} para o responsável ${rta.responsible}.`;

            return desc;
        },
        async validateAllActions() {
            this.validatingActions = true;
            const actionsToValidate = this.actionPlanData.filter(ac => ac.actionStatus === "completed");

            if (this.detailsRta.id === -9999) {
                this.actionValidated = {};
                actionsToValidate.forEach(ac => { this.actionValidated[ac.contextId] = false });
                this.validatingActions = false;
                return;
            }

            const checks = actionsToValidate.map(ac => {
                const url = `${urlMainAPI}/getefficiencyrta/${this.detailsRta.id}/action/${ac.contextId}`;
                return axios.get(url)
                    .then(res => ({ id: ac.contextId, valid: !!(res.data && res.data.effic) }))
                    .catch(() => ({ id: ac.contextId, valid: false }));
            });
            const results = await Promise.all(checks);
            this.actionValidated = {};
            results.forEach(r => { this.actionValidated[r.id] = r.valid });
            this.validatingActions = false;
        },

        async loadRtaById(rtaId) {
            try {
                let rtaFound = null;

                // rtaId pode ser o id numérico ou o código da RTA (ex.: vindo da tela de desvio)
                const numericId = Number(rtaId);
                const isNumericId = !isNaN(numericId);
                const matchRta = (rta) => (isNumericId && rta.id === numericId) || rta.rtaCode === rtaId || rta.code === rtaId;

                const responseOpen = await axios.get(`${urlMainAPI}/getopenrta`);
                if (responseOpen.status === 200 && responseOpen.data) {
                    rtaFound = responseOpen.data.find(matchRta);
                }

                if (!rtaFound) {
                    const responseAll = await axios.get(`${urlMainAPI}/getallrtas`);
                    if (responseAll.status === 200 && responseAll.data) {
                        rtaFound = responseAll.data.find(matchRta);
                    }
                }

                // Fallback: busca direto por ID numérico (inclui canceladas e RTAs antigas fora do filtro de data)
                if (!rtaFound && isNumericId) {
                    const responseById = await axios.get(`${urlMainAPI}/getrtabyid/${numericId}`);
                    if (responseById.status === 200 && responseById.data) {
                        rtaFound = typeof responseById.data === 'string' ? JSON.parse(responseById.data) : responseById.data;
                    }
                }

                if (!rtaFound) {
                    return false;
                }

                // Normaliza os campos para o formato esperado pelo componente
                this.detailsRta = {
                    id: rtaFound.id,
                    code: rtaFound.rtaCode || rtaFound.code || "",
                    desc: rtaFound.description || "",
                    description: rtaFound.description || "",
                    creationDate: rtaFound.creationDate,
                    formattedCreationDate: moment(rtaFound.creationDate).format("YYYY-MM-DD"),
                    stopNote: rtaFound.stopNote || "",
                    deadline: rtaFound.deadline,
                    formattedDeadline: moment(rtaFound.deadline).format("YYYY-MM-DD"),
                    status: rtaFound.status ?? rtaFound.statusId,
                    statusId: rtaFound.statusId ?? rtaFound.status,
                    // Campos de ID
                    indicatorId: rtaFound.indicatorId || null,
                    processId: rtaFound.processId || null,
                    productId: rtaFound.productId || null,
                    equipmentId: rtaFound.equipmentId || null,
                    triggerId: rtaFound.triggerId || null,
                    workshiftId: rtaFound.workshiftId || null,
                    // Campos de nome/descrição
                    indicator: rtaFound.indicatorName || rtaFound.indicator || "",
                    process: rtaFound.processName || rtaFound.process || "",
                    product: rtaFound.productName || rtaFound.product || "",
                    equipment: rtaFound.equipmentName || rtaFound.equipment || "",
                    workshift: rtaFound.workshiftName || rtaFound.workshift || "",
                    trigger: rtaFound.triggerName || rtaFound.trigger || "",
                    responsible: rtaFound.responsibleName || rtaFound.responsible || "",
                    // Campos de responsáveis
                    mainRespId: rtaFound.actionPlanResponsibleId != null ? Number(rtaFound.actionPlanResponsibleId) : (rtaFound.mainRespId != null ? Number(rtaFound.mainRespId) : null),
                    efficiencyRespId: rtaFound.accuracyResponsibleid != null ? Number(rtaFound.accuracyResponsibleid) : (rtaFound.efficiencyRespId != null ? Number(rtaFound.efficiencyRespId) : null),
                    efficiencyRespName: rtaFound.efficiencyRespName || "",
                    // Outros campos
                    auxResponsibles: rtaFound.generalResponsibles || "",
                    generalResponsibles: rtaFound.generalResponsibles || "",
                    relatedRtaId: rtaFound.relatedRtaId || null,
                    value: rtaFound.value || 0,
                    target: rtaFound.target || 0,
                    lowerLimit: rtaFound.lowerLimit || 0,
                    upperLimit: rtaFound.upperLimit || 0,
                    efficiencyrta: rtaFound.efficiencyrta || "",
                    efficiencyaction: rtaFound.efficiencyaction || "",
                    relatedfca: rtaFound.relatedfca || 0,
                };

                this.deadlineModified = false;

                // Processa auxResponsibles
                const incomingAux = this.detailsRta.generalResponsibles ?? this.detailsRta.auxResponsibles;
                this.detailsRta.generalResponsibles = incomingAux;
                this.detailsRta.auxResponsibles = incomingAux;

                if (typeof this.detailsRta.auxResponsibles === 'string') {
                    const raw = this.detailsRta.auxResponsibles;
                    if (raw === "" || raw === "Não encontrado." || raw === "-") {
                        this.detailsRta.auxResponsibles = [];
                    } else {
                        try { this.detailsRta.auxResponsibles = JSON.parse(raw); }
                        catch (e) { this.detailsRta.auxResponsibles = []; }
                    }
                } else if (!this.detailsRta.auxResponsibles) {
                    this.detailsRta.auxResponsibles = [];
                }

                // Verifica status para desabilitar edição
                if (this.detailsRta.statusId == 6 || this.detailsRta.statusId == 7 || this.detailsRta.statusId == 10) {
                    this.disableEdit = true;
                }

                // Estado de avaliação/conclusão da RTA
                this.rtaWasConcluded = [6, 10].includes(this.detailsRta.statusId);

                if ([6, 8, 10].includes(this.detailsRta.statusId)) {
                    this.rtaWasEvaluated = true;
                } else {
                    try {
                        const efficRes = await axios.get(`${urlMainAPI}/getefficiencyrta/${this.detailsRta.id}/rta/${this.detailsRta.id}`);
                        this.rtaWasEvaluated = !!(efficRes.data && efficRes.data.effic);
                    } catch {
                        this.rtaWasEvaluated = false;
                    }
                }

                // Salva no sessionStorage
                sessionStorage.setItem("currentRTA", JSON.stringify(this.detailsRta));

                return true;
            } catch (error) {
                console.error("Erro ao carregar RTA por ID:", error);
                return false;
            }
        },

        async reloadRtaData() {
            // Recarrega os dados da RTA após salvar para atualizar auxResponsibles
            if (this.detailsRta.id && this.detailsRta.id !== -9999) {
                try {
                    const response = await axios.get(`${urlMainAPI}/getopenrta`, {
                        params: { indicatorId: this.detailsRta.indicatorId }
                    });

                    if (response.data && response.data.length > 0) {
                        const updatedRta = response.data.find(r => r.id === this.detailsRta.id);
                        if (updatedRta) {
                            // Atualiza os campos relevantes mantendo os que já foram calculados localmente
                            const incomingAux = updatedRta.generalResponsibles ?? updatedRta.auxResponsibles;
                            this.detailsRta.generalResponsibles = incomingAux;
                            this.detailsRta.auxResponsibles = incomingAux;
                            this.detailsRta.analysisRespId = updatedRta.analysisRespId;
                            this.detailsRta.analysisRespName = updatedRta.analysisRespName;
                            this.detailsRta.actionPlanRespId = updatedRta.actionPlanRespId;
                            this.detailsRta.actionPlanRespName = updatedRta.actionPlanRespName;

                            // Converte auxResponsibles de string para array se necessário
                            if (typeof this.detailsRta.auxResponsibles === 'string') {
                                try {
                                    this.detailsRta.auxResponsibles = JSON.parse(this.detailsRta.auxResponsibles);
                                } catch (e) {
                                    this.detailsRta.auxResponsibles = [];
                                }
                            } else if (!this.detailsRta.auxResponsibles) {
                                this.detailsRta.auxResponsibles = [];
                            }

                            // Atualiza o sessionStorage
                            sessionStorage.setItem('currentRTA', JSON.stringify(this.detailsRta));

                            // NÃO popula automaticamente após reload!
                            // Se o usuário removeu algum responsável, deve respeitar a edição
                        }
                    }
                } catch (error) {
                    console.error('Erro ao recarregar dados da RTA:', error);
                }
            }
        },

        openAddParticipantModal() {
            this.selectedParticipantId = null;
            this.tempParticipants = [];
            this.$bvModal.show('addParticipantModal');
        },

        addParticipantToList() {
            if (!this.selectedParticipantId) return;

            const selectedUser = this.usersResps.find(u => u.id === this.selectedParticipantId);
            if (!selectedUser) return;

            // Adiciona à lista temporária com flag isAutomatic: false (usuário manual)
            this.tempParticipants.push({
                UserId: selectedUser.id,
                UserName: selectedUser.name,
                isAutomatic: false  // Usuário adicionado manualmente - NÃO pode tratar RTA
            });

            // Limpa a seleção
            this.selectedParticipantId = null;
        },

        removeTempParticipant(index) {
            this.tempParticipants.splice(index, 1);
        },

        async confirmAddParticipants() {
            if (this.tempParticipants.length === 0) return;

            // Inicializa auxResponsibles se não existir
            if (!this.detailsRta.auxResponsibles || typeof this.detailsRta.auxResponsibles === 'string') {
                this.detailsRta.auxResponsibles = [];
            }

            // Adiciona os participantes temporários à lista principal
            // Cada um vem com isAutomatic: false
            this.detailsRta.auxResponsibles = [
                ...this.detailsRta.auxResponsibles,
                ...this.tempParticipants
            ];

            // Mantém generalResponsibles alinhado com auxResponsibles
            this.detailsRta.generalResponsibles = this.detailsRta.auxResponsibles;

            // Limpa e fecha o modal
            this.tempParticipants = [];
            this.selectedParticipantId = null;
            this.$bvModal.hide('addParticipantModal');

            defaultSuccess('Participantes adicionados. Clique em Salvar para gravar.');
        },

        cancelAddParticipants() {
            this.tempParticipants = [];
            this.selectedParticipantId = null;
            this.$bvModal.hide('addParticipantModal');
        },

        async removeParticipant(userId) {
            if (!this.detailsRta.auxResponsibles || this.detailsRta.auxResponsibles.length === 0) return;

            // Remove o participante pelo UserId (pode ser automático ou manual)
            this.detailsRta.auxResponsibles = this.detailsRta.auxResponsibles.filter(p => p.UserId !== userId);

            // Mantém generalResponsibles alinhado com auxResponsibles
            this.detailsRta.generalResponsibles = this.detailsRta.auxResponsibles;

            defaultSuccess('Participante removido. Clique em Salvar para gravar.');
        },

        showWarn(msg) {
            this.$bvToast.toast(msg, {
                title: 'Atenção',
                variant: 'warning',
                toaster: 'b-toaster-bottom-left',
                solid: true
            });
        },

        formatDate(dateString) {
            if (!dateString) return '-';
            try {
                // Formato esperado: "yyyy-MM-dd HH:mm:ss" ou similar
                const date = moment(dateString);
                return date.format('DD/MM/YYYY - HH:mm');
            } catch (e) {
                return dateString;
            }
        },

        async openLinkedOccurrencesModal() {
            // Primeiro verifica se o indicador tem indicadores vinculados ANTES de abrir o modal
            try {
                const checkUrl = `${urlMainAPI}/rtaindicatorsrelated/getbyindicator/${this.detailsRta.indicatorId}`;
                const checkResponse = await axios.get(checkUrl);

                let hasLinkedIndicators = false;
                if (checkResponse.data) {
                    const relatedData = typeof checkResponse.data === 'string' ? JSON.parse(checkResponse.data) : checkResponse.data;
                    hasLinkedIndicators = Array.isArray(relatedData) && relatedData.length > 0;
                }

                if (!hasLinkedIndicators) {
                    this.showWarn('Este indicador não possui indicadores vinculados para que seja exibido as FCAs');
                    return;
                }
            } catch (error) {
                showError('Falha ao verificar indicadores vinculados.');
                return;
            }

            // Só abre o modal se houver indicadores vinculados
            this.linkedOccurrences = [];
            this.allLinkedOccurrences = [];
            this.linkedIndicatorsList = [];
            this.linkedIndicatorInfo = {};
            this.loadingLinkedOccurrences = true;
            this.$bvModal.show('fcaViewModal');

            try {
                // O backend agora calcula o período automaticamente baseado no gatilho que disparou a RTA
                const url = `${urlMainAPI}/getlinkedindicatorsoccurrences/${this.detailsRta.id}`;
                const response = await axios.get(url);

                let occurrences = [];
                if (response.data && Array.isArray(response.data)) {
                    occurrences = response.data;
                } else if (typeof response.data === 'string') {
                    const parsed = JSON.parse(response.data);
                    occurrences = Array.isArray(parsed) ? parsed : [];
                }

                // Formata as ocorrências para o formato esperado pelo ManageAllOccurrences
                this.allLinkedOccurrences = occurrences.map(occ => {
                    return {
                        ...occ,
                        trigger: occ.trigger || 'MAN',
                        content: typeof occ.content === 'string' ? JSON.parse(occ.content) : occ.content,
                        description: occ.description || '',
                        reasonContent: occ.reasonContent || null
                    };
                });

                this.linkedOccurrences = [...this.allLinkedOccurrences];

                // Cria lista única de indicadores para o filtro
                const indicatorsMap = new Map();
                this.allLinkedOccurrences.forEach(occ => {
                    if (occ.indicatorId && occ.indicatorName && !indicatorsMap.has(occ.indicatorId)) {
                        indicatorsMap.set(occ.indicatorId, {
                            id: occ.indicatorId,
                            name: occ.indicatorName
                        });
                    }
                });
                this.linkedIndicatorsList = Array.from(indicatorsMap.values());

                // Prepara informações do indicador para passar ao ManageAllOccurrences
                if (this.linkedOccurrences.length > 0) {
                    this.linkedIndicatorInfo = {
                        id: this.detailsRta.indicatorId,
                        indicatorName: this.detailsRta.indicatorName || 'Indicadores Vinculados',
                        occurrences: this.linkedOccurrences.length
                    };
                } else {
                    this.loadingLinkedOccurrences = false;
                    showError('Nenhuma ocorrência encontrada para os indicadores vinculados no período.');
                }
            } catch (error) {
                showError('Falha ao carregar ocorrências dos indicadores vinculados.');
                this.linkedOccurrences = [];
            } finally {
                this.loadingLinkedOccurrences = false;
            }
        },

        reloadLinkedOccurrences() {
            // Função para recarregar as ocorrências após alguma ação
            this.openLinkedOccurrencesModal();
        },

        filterLinkedOccurrences(indicatorId) {
            // Filtra as ocorrências pelo indicador selecionado
            if (indicatorId === null || indicatorId === undefined) {
                // Mostra todas as ocorrências
                this.linkedOccurrences = [...this.allLinkedOccurrences];
            } else {
                // Filtra pelo indicador selecionado
                this.linkedOccurrences = this.allLinkedOccurrences.filter(occ => occ.indicatorId === indicatorId);
            }

            // Atualiza as informações do indicador
            if (this.linkedOccurrences.length > 0) {
                this.linkedIndicatorInfo = {
                    id: this.detailsRta.indicatorId,
                    indicatorName: this.detailsRta.indicatorName || 'Indicadores Vinculados',
                    occurrences: this.linkedOccurrences.length
                };
            }
        },

        goBack() {
            try {
                const returnRoute = sessionStorage.getItem('rtaReturnRoute');
                if (returnRoute) {
                    const route = JSON.parse(returnRoute);
                    // Remove do sessionStorage após usar
                    sessionStorage.removeItem('rtaReturnRoute');
                    this.$router.push(route).catch(err => console.error(err));
                } else {
                    // Fallback: voltar para lista geral
                    this.$router.push({ name: 'rtalist' }).catch(err => console.error(err));
                }
            } catch (error) {
                console.error('Erro ao voltar:', error);
                // Fallback em caso de erro
                this.$router.push({ name: 'rtalist' }).catch(err => console.error(err));
            }
        },

        addActionLine() {
            const newAction = {
                mainReason: "", what: "", how: "", where: "", howMuch: "", who: "",
                whenInitPrev: "", whenFinishPrev: "", whenInitReal: "", whenFinishReal: "",
                actionType: "", actionStatus: "not-started", actionAcc: "", actionDelete: "",
                linkedFromKey: null, linkedFromOrigin: null,
                rowKey: this.newRowKey(), contextId: uuidv4()
            };
            this.actionPlanData.push(newAction);
        },

        validateMainCausesRequired() {
            const isEmpty = v => !(v || "").toString().trim();
            const pend5pq   = this.porquesData.filter(r  => isEmpty(r.mainCause)).length;
            const pendIshik = this.ishikawaData.filter(r => isEmpty(r.mainCause)).length;
            const pendAct   = this.actionPlanData.filter(r => isEmpty(r.mainReason)).length;
            return { pend5pq, pendIshik, pendAct, ok: (pend5pq + pendIshik + pendAct) === 0 };
        },

        newRowKey() {
            return Date.now() + Math.random();
        },

        triggerFlash(targetRow) {
            if (!targetRow) return;
            this.$set(targetRow, "_flashAt", true);
            setTimeout(() => { if (targetRow) this.$set(targetRow, "_flashAt", null); }, 2100);
        },

        onMainCauseBlur({ row, origin }) {
            const text = (row.mainCause || "").toString().trim();
            row.mainCause = text;

            if (!row.rowKey) row.rowKey = this.newRowKey();

            const linked = this.actionPlanData.find(a => a.linkedFromKey === row.rowKey);

            // CF de origem esvaziada: limpa a linha vinculada para não deixar ação órfã com valor invisível
            if (!text) {
                if (linked && linked.mainReason) {
                    linked.mainReason = "";
                    this.triggerFlash(linked);
                }
                return;
            }

            if (linked) {
                if (linked.mainReason !== text) linked.mainReason = text;
                this.triggerFlash(linked);
                return;
            }

            // adota ação existente não-vinculada com o mesmo texto (dados legados ou seleção manual) em vez de duplicar
            const orphan = this.actionPlanData.find(a => !a.linkedFromKey && (a.mainReason || "").toString().trim() === text);
            if (orphan) {
                orphan.linkedFromKey = row.rowKey;
                orphan.linkedFromOrigin = origin;
                this.triggerFlash(orphan);
                return;
            }

            const newAction = {
                mainReason: text,
                what: "", how: "", where: "", howMuch: "", who: "",
                whenInitPrev: "", whenFinishPrev: "", whenInitReal: "", whenFinishReal: "",
                actionType: "", actionStatus: "not-started", actionAcc: "", actionDelete: "",
                linkedFromKey: row.rowKey, linkedFromOrigin: origin,
                rowKey: this.newRowKey(), contextId: uuidv4()
            };
            this.actionPlanData.push(newAction);
            this.$nextTick(() => this.triggerFlash(newAction));
        },


        validateRequiredFields() {
            if (this.detailsRta.indicatorId == null ||
                this.detailsRta.mainRespId == null ||
                this.detailsRta.processId == null ||
                this.detailsRta.efficiencyRespId == null ||
                this.detailsRta.formattedDeadline == "" ||
                this.detailsRta.formattedCreationDate == ""
            ) {
                return false;
            }
            return true;
        },

        validateActionDates() {
            // Valida se todas as ações têm Início Previsto e Término Previsto preenchidos
            if (this.actionPlanData.length === 0) {
                return true; // Se não há ações, está válido
            }

            for (let action of this.actionPlanData) {
                if (!action.whenInitPrev || action.whenInitPrev === "" ||
                    !action.whenFinishPrev || action.whenFinishPrev === "") {
                    return false;
                }
            }

            return true;
        },

        allActionsComplete() {
            let res = true;

            if (this.actionPlanData.length > 0) {
                // Valida apenas as ações OBRIGATÓRIAS — concluídas = avaliadas (completed ou completed-late)
                this.actionPlanData.forEach(ac => {
                    if (ac.actionType == "obrigatorio" &&
                        ac.actionStatus != "completed" &&
                        ac.actionStatus != "completed-late") res = false;
                });
            }

            return res;
        },

        onEfficSaved({ efficData, efftype }) {
            if (efftype === 'action') {
                const idx = this.actionPlanData.findIndex(
                    a => String(a.contextId) === String(efficData.actionId)
                );
                if (idx !== -1) {
                    this.$set(this.actionPlanData[idx], 'evaluationData', efficData);
                    this.updateAllActionStatuses();
                }
            } else if (efftype === 'rta') {
                this.rtaWasEvaluated = true;
                if (efficData && efficData.approveEfficiency) {
                    this.rtaWasConcluded = true;
                }
            }
            this.$bvModal.hide('rtaGeneralEfficModal');
        },

        async handleEfficDeal(type, id) {
            if (type === 'rta') {
                if (!this.loadedHasReason && !this.loadedHasActions) {
                    this.showWarn("Salve Causa Raiz e Plano de Ação antes de avaliar RTA");
                    return;
                }

                if (!this.loadedHasReason) {
                    this.showWarn("Salve Causa Raiz antes de avaliar RTA");
                    return;
                }

                if (!this.loadedHasActions) {
                    this.showWarn("Salve o Plano de Ação antes de avaliar RTA");
                    return;
                }

                // Validar que todas as ações têm datas previstas preenchidas
                if (!this.validateActionDates()) {
                    this.showWarn("Todas as ações do Plano devem ter Início Previsto e Término Previsto preenchidos");
                    return;
                }

                // Validar que todas as ações obrigatórias estão finalizadas
                if (!this.allActionsComplete()) {
                    this.showWarn("Finalize todas as ações obrigatórias antes de avaliar RTA");
                    return;
                }

                // Validar que todas as ações finalizadas foram avaliadas individualmente
                if (this.avaliateEfficActionType === 0) {
                    await this.validateAllActions();
                    if (!this.allFinishedActionsEvaluated) {
                        this.showWarn("Avalie individualmente todas as ações finalizadas antes de avaliar a RTA");
                        return;
                    }
                }
            }

            this.effitCtype = type;
            this.effitCRelatedId = id;

            this.$bvModal.show('rtaGeneralEfficModal')
        },

        toggleDetailsInfo() {
            this.showDetailsInfo = !this.showDetailsInfo;
            this.changeTableSizes();
        },

        changeTableSizes() {
            if (this.showDetailsInfo == false) {
                if (window.innerWidth > 1600) {
                    this.actionTableHeight = 430;
                    this.reasonTableHeight = 410;
                } else {
                    this.actionTableHeight = 232;
                    this.reasonTableHeight = 210;
                }
            } else {
                if (window.innerWidth > 1600) {
                    this.actionTableHeight = 330;
                    this.reasonTableHeight = 310;
                } else {
                    this.actionTableHeight = 130;
                    this.reasonTableHeight = 105;
                }
            }
        },

        onResize() {
            this.changeTableSizes();
        },

        addReasonLine(listType) {
            if (listType == 0) {
                this.ishikawaData.push({
                    sixm: '',
                    firstCause: '',
                    secondCause: '',
                    thirdCause: '',
                    fourthCause: '',
                    fifthCause: '',
                    sixthCause: '',
                    mainCause: '',
                    actionDelete: '',
                    rowKey: this.newRowKey()
                });
            }
            else if (listType == 1) {
                this.porquesData.push({
                    firstPq: '',
                    secondPq: '',
                    thirdPq: '',
                    fourthPq: '',
                    fifthPq: '',
                    mainCause: '',
                    origin: '',
                    actionDelete: '',
                    rowKey: this.newRowKey()
                })
            }
        },

        handleDeleteLine() {
            if (this.lineToDelete.type == 'actions') {
                // remover ação do Plano não afeta a Identificação de Causa Raiz
                this.actionPlanData = this.filterDelete(this.actionPlanData, this.lineToDelete.data.rowKey)
            } else if (this.lineToDelete.type == 'ishik') {
                this.ishikawaData = this.filterDelete(this.ishikawaData, this.lineToDelete.data.rowKey)
                this.removeLinkedActions(this.lineToDelete.data.rowKey, this.lineToDelete.data.mainCause)
            } else if (this.lineToDelete.type == '5pq') {
                this.porquesData = this.filterDelete(this.porquesData, this.lineToDelete.data.rowKey)
                this.removeLinkedActions(this.lineToDelete.data.rowKey, this.lineToDelete.data.mainCause)
            }

            this.$bvModal.hide('rtaDealDelete')
        },

        // remove a ação vinculada e as manuais de mesma CF, se nenhuma outra causa raiz ainda usar o texto
        removeLinkedActions(reasonRowKey, reasonMainCause) {
            const text = (reasonMainCause || "").toString().trim();
            const causeStillExists = !!text && (
                this.ishikawaData.some(r => (r.mainCause || "").toString().trim() === text) ||
                this.porquesData.some(r => (r.mainCause || "").toString().trim() === text)
            );
            this.actionPlanData = this.actionPlanData.filter(a => {
                if (a.linkedFromKey === reasonRowKey) return false;
                if (text && !causeStillExists && (a.mainReason || "").toString().trim() === text) return false;
                return true;
            });
        },

        getLineToDelete(item) {
            this.lineToDelete = item;
        },

        filterDelete(array, id) {
            if (array.length > 0) {
                return array.filter(i => i.rowKey != id);
            } else {
                return array
            }
        },

        async loadUsers() {
            await axios.get(`${urlMainAPI}/getusers`)
                .then(res => {
                    this.usersResps = res.data;
                }).catch(err => console.error(err))
        },

        resolveResponsibleId(value) {
            if (value == null || value === "") return value;
            if (typeof value === "number") return value;
            if (typeof value === "string" && /^\d+$/.test(value)) return Number(value);
            const match = this.usersResps.find(u => u.name === value);
            return match ? match.id : value;
        },

        async loadProductionInfos() {
            await axios.get(`${urlMainAPI}/getproductioninfos`)
                .then(res => {
                    this.process = res.data.allProcess;
                    this.products = res.data.allProducts;
                    this.equipment = res.data.allEquipment;
                    this.allIndicators = res.data.allIndicators.sort((a, b) => {
                        const nameA = a.indicatorName || '';
                        const nameB = b.indicatorName || '';

                        const startsWithLetterA = /^[a-zA-ZÀ-ÿ]/.test(nameA);
                        const startsWithLetterB = /^[a-zA-ZÀ-ÿ]/.test(nameB);

                        if (!startsWithLetterA && startsWithLetterB) return -1;
                        if (startsWithLetterA && !startsWithLetterB) return 1;

                        return nameA.localeCompare(nameB, 'pt-BR', { ignorePunctuation: true });
                    });
                }).catch(err => console.error(err))
        },

        async getDealingReasonActionTables() {
            if (this.detailsRta.id == -9999) return;
            await axios.get(`${urlMainAPI}/getdealingtablesrta/${this.detailsRta.id}`)
                .then(res => {
                    let reasons = res.data.reasons;
                    let actions = res.data.actions;


                    this.reasonDetails = {
                        dealingId: reasons.id,
                        effect: reasons.effect,
                        respAnalysisId: reasons.analysisResponsibleId,
                        respRole: reasons.analysisResponsibleRole,
                        analysisDate: reasons.analysisDate ? moment(reasons.analysisDate).format("YYYY-MM-DD") : moment(Date.now()).format("YYYY-MM-DD"),
                        deafultDate: reasons.analysisDate,
                    }

                    this.actionDetails = {
                        dealingId: actions.id,
                        respActionId: actions.actionPlanResponsibleId,
                        respActionRole: actions.actionPlanResponsibleRole,
                        actionDate: actions.actionPlanDate ? moment(actions.actionPlanDate).format("YYYY-MM-DD") : moment(Date.now()).format("YYYY-MM-DD"),
                        deafultDate: actions.actionPlanDate,
                    }


                    if (actions.tableContent != "") {
                        try {
                            let content = JSON.parse(actions.tableContent);
                            if (content.actions) {
                                const actionEfficiencies = res.data.actionEfficiencies || [];
                                const effMap = {};
                                actionEfficiencies.forEach(e => { effMap[String(e.actionId)] = e; });

                                this.actionPlanData = content.actions.map(a => ({
                                    linkedFromKey: null,
                                    linkedFromOrigin: null,
                                    ...a,
                                    rowKey: a.rowKey || (this.newRowKey()),
                                    who: this.resolveResponsibleId(a.who),
                                    evaluationData: effMap[String(a.contextId)] ?? null,
                                    _savedDates: {
                                        whenInitPrev:   a.whenInitPrev   || null,
                                        whenFinishPrev: a.whenFinishPrev || null,
                                        whenInitReal:   a.whenInitReal   || null,
                                        whenFinishReal: a.whenFinishReal || null,
                                    }
                                }));
                                this.updateAllActionStatuses();
                            }
                        } catch (e) { console.error("Erro ao parsear tableContent de ações:", e) }
                    }

                    if (reasons.tableContent != "") {
                        try {
                            let content = JSON.parse(reasons.tableContent)
                            if (content.ishikawa) this.ishikawaData = content.ishikawa.map(r => ({ ...r, rowKey: r.rowKey || (this.newRowKey()) }));
                            if (content.fivepq)   this.porquesData  = content.fivepq.map(r   => ({ ...r, rowKey: r.rowKey || (this.newRowKey()) }));
                        } catch (e) { console.error("Erro ao parsear tableContent de causas:", e) }
                    }

                    this.loadedHasReason = this.ishikawaData.length > 0 || this.porquesData.length > 0;
                    this.loadedHasActions = this.actionPlanData.length > 0;

                    defaultSuccess("Relatórios Carregados com Sucesso!")

                    // Carregar anexos da causa raiz
                    this.loadReasonAttachments();

                })
                .catch(() => showError("Falha ao Carregar Relatórios."))
        },

        async loadDealingIdsOnly() {
            if (this.detailsRta.id == -9999) return;

            try {
                const res = await axios.get(`${urlMainAPI}/getdealingtablesrta/${this.detailsRta.id}`);
                const reasons = res.data.reasons;
                const actions = res.data.actions;

                this.reasonDetails = { ...this.reasonDetails, dealingId: reasons.id };
                this.actionDetails = { ...this.actionDetails, dealingId: actions.id };

                defaultSuccess("IDs de Dealing carregados com sucesso!");

            } catch {
                showError("Falha ao carregar IDs de Dealing.");
            }
        },

        async saveDealingReasonActionTables() {
            const stripTransient = (row) => {
                const r = { ...row };
                delete r.evaluationData;
                delete r._savedDates;
                delete r._flashAt;
                return r;
            };
            const sanitizedActions = this.actionPlanData.map(stripTransient);
            let actionsObj = {
                dealingId: this.actionDetails.dealingId,
                rtaId: this.detailsRta.id,
                tableType: 0,
                respId: this.actionDetails.respActionId,
                respRole: this.actionDetails.respActionRole,
                tableDate: this.actionDetails.deafultDate != "" ? moment(this.actionDetails.deafultDate) : moment(Date.now()),
                tableAggregationContent: JSON.stringify({ actions: sanitizedActions })
            }

            let reasons = {
                dealingId: this.reasonDetails.dealingId,
                rtaId: this.detailsRta.id,
                effect: this.reasonDetails.effect,
                tableType: 1,
                respId: this.reasonDetails.respAnalysisId,
                respRole: this.reasonDetails.respRole,
                tableDate: this.reasonDetails.deafultDate != "" ? moment(this.reasonDetails.deafultDate) : moment(Date.now()),
                tableAggregationContent: JSON.stringify({
                    ishikawa: this.ishikawaData.map(stripTransient),
                    fivepq: this.porquesData.map(stripTransient)
                })
            }

            if (this.isManual == true) {
                actionsObj.rtaId = this.detailsRta.id;
                reasons.rtaId = this.detailsRta.id;
            }

            await axios.post(`${urlMainAPI}/savedealingtablesrta`, [actionsObj, reasons])
                .then(async () => {
                    // Travar as datas recém-salvas
                    this.actionPlanData = this.actionPlanData.map(a => ({
                        ...a,
                        _savedDates: {
                            whenInitPrev:   a.whenInitPrev   || null,
                            whenFinishPrev: a.whenFinishPrev || null,
                            whenInitReal:   a.whenInitReal   || null,
                            whenFinishReal: a.whenFinishReal || null,
                        }
                    }));

                    // Atualizar as flags de carregamento após salvar com sucesso
                    this.loadedHasReason = this.ishikawaData.length > 0 || this.porquesData.length > 0;
                    this.loadedHasActions = this.actionPlanData.length > 0;

                    // Aguardar um momento para garantir que os IDs foram atualizados
                    await this.loadDealingIdsOnly();

                    // Salvar anexos da causa raiz se houver
                    if (this.reasonAttachments.files.length > 0 || this.reasonAttachments.links.length > 0) {
                        await this.saveReasonAttachments();
                    }

                    // Recarregar dados da RTA para atualizar auxResponsibles
                    await this.reloadRtaData();

                    defaultSuccess("Relatórios Armazenados com Sucesso!")
                })
                .catch(() => showError("Falha ao Armazenar Relatórios."))
        },

        handleReasonAttachmentsChange(data) {
            this.reasonAttachments.files = data.files;
            this.reasonAttachments.links = data.links;
        },

        async saveReasonAttachments() {
            if (!this.reasonDetails.dealingId || this.reasonDetails.dealingId === -9999) {
                return; // Não salvar anexos se a análise ainda não foi criada
            }

            let filesToSend = null;
            const zip = new JSZip();

            // Processar arquivos se houver
            if (Array.isArray(this.reasonAttachments.files) && this.reasonAttachments.files.length > 0) {
                this.reasonAttachments.files.forEach(file => {
                    const base64Data = file.data.split(',')[1];
                    zip.file(file.name, base64Data, { base64: true });
                });
            }

            // Adicionar links como arquivo de texto se houver
            if (this.reasonAttachments.links.length > 0) {
                const linksText = this.reasonAttachments.links.map(link =>
                    `${link.description || 'Link'}: ${link.url}`
                ).join('\n');
                zip.file('links.txt', linksText);
            }

            // Gerar ZIP se houver arquivos ou links
            if (this.reasonAttachments.files.length > 0 || this.reasonAttachments.links.length > 0) {
                const zipBase64 = await zip.generateAsync({ type: "base64" });
                filesToSend = {
                    id: this.reasonAttachmentFileId || -9999,
                    blob: zipBase64
                };

                await axios.post(`${urlMainAPI}/savereasonattachmentsrta`, {
                    reasonAnalysisId: this.reasonDetails.dealingId,
                    files: filesToSend
                }).then((res) => {
                    // res.data pode ser string JSON ou objeto já parseado
                    const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
                    this.reasonAttachmentFileId = data.filetosave.id;
                    defaultSuccess("Anexos da Causa Raiz salvos com sucesso!");
                }).catch(err => {
                    console.error(err);
                    showError("Falha ao salvar anexos da Causa Raiz.");
                });
            }
        },

        async loadReasonAttachments() {
            if (!this.reasonDetails.dealingId || this.reasonDetails.dealingId === -9999) {
                return;
            }

            try {
                const res = await axios.get(`${urlMainAPI}/getreasonattachmentsrta/${this.reasonDetails.dealingId}`);
                // res.data pode ser string JSON ou objeto já parseado
                const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;

                if (data && data.files && data.files.blob) {
                    this.reasonAttachmentFileId = data.files.id;

                    // Descompactar o ZIP para obter os arquivos originais
                    try {
                        const zip = await JSZip.loadAsync(data.files.blob, { base64: true });
                        const fileList = [];
                        const linkList = [];

                        // Processar cada arquivo no ZIP
                        const filePromises = [];
                        zip.forEach((relativePath, file) => {
                            if (relativePath === 'links.txt') {
                                // Extrair links
                                filePromises.push(
                                    file.async('string').then(content => {
                                        const lines = content.split('\n').filter(l => l.trim());
                                        lines.forEach(line => {
                                            const match = line.match(/^(.+?):\s*(.+)$/);
                                            if (match) {
                                                linkList.push({
                                                    description: match[1].trim() === 'Link' ? '' : match[1].trim(),
                                                    url: match[2].trim()
                                                });
                                            }
                                        });
                                    })
                                );
                            } else {
                                // Extrair arquivo
                                filePromises.push(
                                    file.async('base64').then(content => {
                                        fileList.push({
                                            name: relativePath,
                                            type: this.getFileType(relativePath),
                                            size: file._data.uncompressedSize,
                                            data: 'data:application/octet-stream;base64,' + content
                                        });
                                    })
                                );
                            }
                        });

                        await Promise.all(filePromises);

                        this.reasonAttachments.files = fileList;
                        this.reasonAttachments.links = linkList;

                    } catch (zipError) {
                        console.error('Erro ao descompactar ZIP:', zipError);
                    }
                }
            } catch (err) {
                console.error('Erro ao carregar anexos:', err);
            }
        },

        getFileType(filename) {
            const ext = filename.split('.').pop().toLowerCase();
            const types = {
                'png': 'image/png',
                'jpg': 'image/jpeg',
                'jpeg': 'image/jpeg',
                'pdf': 'application/pdf',
                'doc': 'application/msword',
                'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            };
            return types[ext] || 'application/octet-stream';
        },

        async saveLinkedTriggers() {
            if (this.detailsRta.id == -9999 || !this.secondaryTriggers || this.secondaryTriggers.length === 0) {
                return;
            }

            const linkedTriggersToSave = this.secondaryTriggers.map(trigger => ({
                rtaId: this.detailsRta.id,
                triggerId: trigger.id,
                indicatorId: trigger.indicatorId,
                lowerLimit: trigger.lowerLimit || 0,
                upperLimit: trigger.upperLimit || 0,
                value: trigger.realValue || trigger.value || 0,
                isMain: trigger.isMain || false,
                notes: JSON.stringify({
                    creationDate: trigger.creationDate,
                    indicator: trigger.indicator,
                    process: trigger.process,
                    workshift: trigger.workshift,
                    trigger: trigger.trigger,
                    responsible: trigger.responsible,
                    prevValue: trigger.prevValue || trigger.target,
                    record: trigger.record,
                    shootingDate: trigger.shootingDate
                })
            }));

            await axios.post(`${urlMainAPI}/rta/${this.detailsRta.id}/linked-triggers`, linkedTriggersToSave)
                .then(() => {
                    defaultSuccess("Gatilhos Vinculados Salvos com Sucesso!");
                })
                .catch((error) => {
                    console.error("Erro ao salvar linked triggers:", error);
                    showError("Falha ao Salvar Gatilhos Vinculados.");
                });
        },

        async loadLinkedTriggers() {
            if (this.detailsRta.id == -9999) return;

            await axios.get(`${urlMainAPI}/rta/${this.detailsRta.id}/linked-triggers`)
                .then(res => {
                    if (res.data && res.data.length > 0) {
                        this.secondaryTriggers = res.data.map(lt => {
                            let displayData = {};
                            try {
                                displayData = lt.notes ? JSON.parse(lt.notes) : {};
                            } catch (e) {
                                console.error("Erro ao parsear notes:", e);
                                displayData = {};
                            }

                            return {
                                id: lt.triggerId,
                                triggerId: lt.triggerId,
                                indicatorId: lt.indicatorId,
                                indicator: displayData.indicator || '',
                                process: displayData.process || '',
                                workshift: displayData.workshift || '',
                                trigger: displayData.trigger || '',
                                responsible: displayData.responsible || '',
                                lowerLimit: lt.lowerLimit,
                                upperLimit: lt.upperLimit,
                                prevValue: displayData.prevValue || lt.lowerLimit,
                                realValue: lt.value,
                                creationDate: displayData.creationDate || this.detailsRta.creationDate || '',
                                record: displayData.record || 'RTA Gerada',
                                isMain: lt.isMain || false
                            };
                        });

                    }
                })
                .catch(err => {
                    console.error("Erro ao carregar gatilhos vinculados:", err);
                });
        },

        async saveGeneralInformation(status = null) {
            if (!this.detailsRta.formattedDeadline) {
                showError("O campo Prazo é obrigatório.");
                return false;
            }
            const todayStr = new Date().toLocaleDateString("en-CA");
            if (this.deadlineModified && this.detailsRta.formattedDeadline < todayStr) {
                showError("O prazo não pode ser menor que a data atual.");
                return false;
            }
            if (this.rtaUseMaxDeadline && this.rtaMaxDeadlineDays) {
                const creationDate = new Date(this.detailsRta.creationDate);
                const deadline = new Date(this.detailsRta.formattedDeadline);
                const diffDays = Math.ceil((deadline - creationDate) / (1000 * 60 * 60 * 24));
                if (diffDays > this.rtaMaxDeadlineDays) {
                    showError(`O prazo não pode exceder ${this.rtaMaxDeadlineDays} dias a partir da abertura da RTA.`);
                    return false;
                }
            }

            if (typeof this.detailsRta.creationDate == "number") this.detailsRta.creationDate = new Date(this.detailsRta.creationDate).toISOString()

            // Sempre reconstruir deadline a partir de formattedDeadline para garantir que alterações sejam enviadas
            this.detailsRta.deadline = new Date(this.detailsRta.formattedDeadline).toISOString();

            // Garante que a lista de participantes esteja alinhada
            this.detailsRta.generalResponsibles = this.detailsRta.auxResponsibles;

            // Adiciona Responsável e Resp. Eficácia aos participantes automaticamente (sem duplicar)
            const autoIds = [this.detailsRta.mainRespId, this.detailsRta.efficiencyRespId].filter(id => !!id);
            const auxList = Array.isArray(this.detailsRta.auxResponsibles) ? this.detailsRta.auxResponsibles : [];
            const currentParticipantIds = auxList.map(p => Number(p.UserId));
            for (const userId of autoIds) {
                if (!currentParticipantIds.includes(Number(userId))) {
                    const user = this.usersResps.find(u => u.id === Number(userId));
                    if (user) {
                        auxList.push({ UserId: user.id, UserName: user.name, isAutomatic: true });
                        currentParticipantIds.push(Number(user.id));
                    }
                }
            }
            this.detailsRta.auxResponsibles = auxList;
            this.detailsRta.generalResponsibles = auxList;

            const generalResponsibles = JSON.stringify(this.detailsRta.auxResponsibles || []);
            const isNew = this.detailsRta.id === -9999;

            if (this.isManual == true) {
                this.detailsRta.creationDate = new Date(this.detailsRta.formattedCreationDate).toISOString();
                this.detailsRta.workshiftId = 4;
                this.detailsRta.triggerId = 11;
            }

            let objToSave = {
                id: this.detailsRta.id,
                rtaCode: this.detailsRta.code,
                indicatorId: this.detailsRta.indicatorId,
                processId: this.detailsRta.processId,
                workshiftId: this.detailsRta.workshiftId,
                productId: this.detailsRta.productId,
                equipmentId: this.detailsRta.equipmentId,
                triggerId: this.detailsRta.triggerId,
                creationDate: this.detailsRta.creationDate,
                stopNote: this.detailsRta.stopNote,
                deadline: this.detailsRta.deadline,
                description: this.detailsRta.desc,
                actionPlanResponsibleId: this.detailsRta.mainRespId,
                accuracyResponsibleid: this.detailsRta.efficiencyRespId,
                generalResponsibles: generalResponsibles,

                target: 0,
                value: 0,
                lowerLimit: 0,
                upperLimit: 0,

                status: 0,
            }

            // Compara apenas as datas (sem hora) para determinar se está atrasado
            let todayDate = new Date();
            todayDate.setHours(0, 0, 0, 0);

            let deadlineDate = moment(this.detailsRta.deadline).toDate();
            deadlineDate.setHours(0, 0, 0, 0);

            if (this.reasonDetails.respAnalysisId) {
                if (todayDate > deadlineDate) {
                    objToSave.status = 2;
                } else {
                    objToSave.status = 1;
                }
            }

            if (this.actionDetails.respActionId) {
                if (todayDate > deadlineDate) {
                    objToSave.status = 4;
                } else {
                    objToSave.status = 3;
                }
            }

            if (status != null) {
                objToSave.status = status;
            }

            await axios.post(`${urlMainAPI}/saverta/${isNew}`, [objToSave]).then((res) => {
                // Backend pode retornar string JSON ou array já parseada
                const responseData = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
                const saved = Array.isArray(responseData) ? responseData[0] : responseData;
                const savedStatusId = saved.statusId ?? saved.status;
                this.detailsRta.statusId = savedStatusId;
                if (savedStatusId == 6 || savedStatusId == 7 || savedStatusId == 10) this.disableEdit = true;
                this.rtaWasConcluded = [6, 10].includes(savedStatusId);
                const incomingAux = saved.generalResponsibles ?? saved.auxResponsibles ?? this.detailsRta.auxResponsibles;
                let parsedAux = incomingAux;
                if (typeof incomingAux === 'string') {
                    try {
                        parsedAux = JSON.parse(incomingAux);
                    } catch {
                        parsedAux = [];
                    }
                }
                this.detailsRta = { ...this.detailsRta, id: saved.id, rtaCode: saved.rtaCode, code: saved.rtaCode, auxResponsibles: parsedAux, generalResponsibles: parsedAux, deadline: saved.deadline, formattedDeadline: saved.deadline ? moment(saved.deadline).format("YYYY-MM-DD") : this.detailsRta.formattedDeadline }
                sessionStorage.setItem("currentRTA", JSON.stringify(this.detailsRta));
                defaultSuccess("RTA Atualizada com Sucesso!");
            }).catch(() => showError("Falha ao Atualizar RTA."))
        },

        onSaveClick() {
            if (this.detailsRta.id === -9999) {
                this.$bvModal.show('confirmSaveNewRtaModal');
            } else {
                this.handleSave(null);
            }
        },

        confirmSaveNewRta() {
            this.$bvModal.hide('confirmSaveNewRtaModal');
            this.handleSave(null);
        },

        async handleSave(status = null) {
            if (this.actionPlanData.length > 0 && (!this.actionDetails.respActionId || this.actionDetails.respActionId === 0)) {
                this.$bvToast.toast("Selecione um Responsável pelos planos de ações cadastrados antes de salvar RTA.",
                    {
                        title: "Responsável não definido!",
                        variant: "warning",
                        toaster: "b-toaster-bottom-left",
                        solid: true,
                    }
                );
                return;
            }

            const totalCausas = this.ishikawaData.length + this.porquesData.length;
            if (totalCausas > 0 && (!this.reasonDetails.respAnalysisId || this.reasonDetails.respAnalysisId === 0)) {
                this.$bvToast.toast("Selecione um Responsável pela Análise da Causa Raiz antes de salvar RTA.", {
                    title: "Responsável não definido!",
                    variant: "warning",
                    toaster: "b-toaster-bottom-left",
                    solid: true,
                });
                return;
            }

            if (!this.validateRequiredFields()) {
                this.$bvToast.toast("Preencha os campos do detalhamento antes de salvar.", {
                    title: "Campos obrigatórios em branco!",
                    variant: "warning",
                    toaster: 'b-toaster-bottom-left',
                    solid: true
                });
                return;
            }

            const cfCheck = this.validateMainCausesRequired();
            if (!cfCheck.ok) {
                const parts = [];
                if (cfCheck.pend5pq)   parts.push(`${cfCheck.pend5pq} linha(s) em 5 Porquês`);
                if (cfCheck.pendIshik) parts.push(`${cfCheck.pendIshik} linha(s) em 6Ms`);
                if (cfCheck.pendAct)   parts.push(`${cfCheck.pendAct} linha(s) no Plano de Ação`);
                this.$bvToast.toast(`Causa Fundamental é obrigatória. Pendências: ${parts.join(", ")}.`, {
                    title: "Causa Fundamental obrigatória",
                    variant: "warning",
                    toaster: "b-toaster-bottom-left",
                    solid: true
                });
                return;
            }

            // Validar que todas as ações têm datas previstas preenchidas
            if (!this.validateActionDates()) {
                this.$bvToast.toast("Todas as ações do Plano devem ter Início Previsto e Término Previsto preenchidos.", {
                    title: "Datas obrigatórias em branco!",
                    variant: "warning",
                    toaster: 'b-toaster-bottom-left',
                    solid: true
                });
                return;
            }

            if (status === 6) {
                if (!this.loadedHasReason && !this.loadedHasActions) {
                    this.showWarn("Salve Causa Raiz e Plano de Ação antes de concluir a RTA");
                    return;
                }

                if (!this.loadedHasReason) {
                    this.showWarn("Salve Causa Raiz antes de concluir a RTA");
                    return;
                }

                if (!this.loadedHasActions) {
                    this.showWarn("Salve o Plano de Ação antes de concluir a RTA");
                    return;
                }

                // Validar que todas as ações obrigatórias estão finalizadas
                if (!this.allActionsComplete()) {
                    this.$bvToast.toast("Finalize todas as ações obrigatórias antes de concluir a RTA.", {
                        title: "Ações Obrigatórias Pendentes!",
                        variant: "warning",
                        toaster: 'b-toaster-bottom-left',
                        solid: true
                    });
                    return;
                }

                // Validar que todas as ações finalizadas foram avaliadas individualmente
                if (this.avaliateEfficActionType === 0) {
                    await this.validateAllActions();
                    if (!this.allFinishedActionsEvaluated) {
                        this.showWarn("Avalie individualmente todas as ações finalizadas antes de concluir a RTA");
                        return;
                    }
                }

                // Validar que a avaliação geral da RTA foi feita (quando habilitada)
                if (!this.rtaRatingOff && !this.rtaWasEvaluated) {
                    this.showWarn("Avalie a RTA antes de concluí-la");
                    return;
                }
            }

            this.loading = true;
            const saved = await this.saveGeneralInformation(status);
            if (saved === false) {
                this.loading = false;
                return;
            }
            await this.loadDealingIdsOnly();

            await this.saveDealingReasonActionTables();
            await this.saveLinkedTriggers();
            if (status === 6) this.rtaWasConcluded = true;
            this.loading = false;
        },

        async loadGeneralConfig() {
            await axios.get(`${urlMainAPI}/getGeneralConfigGerencialIndicators`)
                .then(res => {
                    if (res.data) {
                        this.avaliateEfficActionType = res.data.actionPlanRating;
                        this.analysisType = res.data.analysesMetd;
                        this.rtaRatingOff = res.data.rtaRatingOff === true;
                        this.disableAttachmentRequirement = res.data.disableAttachmentRequirement || false;
                        this.rtaUseMaxDeadline = res.data.useMaxDeadline == true;
                        this.rtaMaxDeadlineDays = res.data.maxDeadlineDays;

                        // Oculta coluna Eficácia quando não é avaliação "Por Ação" (valor 0)
                        if (this.avaliateEfficActionType != 0) {
                            this.actionPlanCols = this.actionPlanCols.filter(item => item.field != "actionAcc");
                        }
                    }
                })
                .catch(err => {
                    this.stopLoading();
                    console.error(err)
                })
        },

        async loadRelatedIndicatorId() {
            if (this.detailsRta.indicatorId == null) return;

            await axios.get(`${urlMainAPI}/getrelatedrtaindicatorlist/${this.detailsRta.indicatorId}`)
                .then(res => {
                    if (res.data && res.data.length) {
                        this.relatedIndicators = [...res.data]
                        this.relatedSelected = { id: this.relatedIndicators[0].indicatorId, indicatorId: this.relatedIndicators[0].indicatorId, description: "", actionsList: [], content: { actionsList: [] } };
                    }
                })
                .catch(err => console.error(err))
        },

        validatePermissions() {
            let permissions = { ...this.user.Permissions };

            if (permissions.rtacriarmanualmente && permissions.rtacriarmanualmente.allowed == true && this.isManual) {
                this.pagePermissions.isManual = true;
                this.pagePermissions.isMainResp = true;
                this.pagePermissions.isAuxResp = true;
                this.pagePermissions.isActionReasonResp = true;
                this.pagePermissions.canFinish = true;
                this.pagePermissions.canAvaliate = true;
                this.pagePermissions.canCancel = true;
                return;
            }

            if (permissions.rtacancelar && permissions.rtacancelar.allowed == true) this.pagePermissions.canCancel = true;

            if (permissions.rtaeficacia && permissions.rtaeficacia.allowed == true) {
                if (this.detailsRta.efficiencyRespId && this.user.Id == this.detailsRta.efficiencyRespId.toString()) this.pagePermissions.canAvaliate = true;
            }

            if (permissions.rtacausaraizeacao && permissions.rtacausaraizeacao.allowed == true) {
                if (this.reasonDetails.respAnalysisId && this.actionDetails.respActionId && (this.user.Id == this.reasonDetails.respAnalysisId.toString() || this.user.Id == this.actionDetails.respActionId.toString())) {
                    this.pagePermissions.isActionReasonResp = true;
                }
            }

            if (this.detailsRta.mainRespId && this.user.Id == this.detailsRta.mainRespId.toString()) this.pagePermissions.isMainResp = true;

            // Permissões NÃO vêm do auxResponsibles!
            // auxResponsibles é apenas para EXIBIÇÃO visual
            // Permissões vêm dos campos individuais verificados acima

            if (permissions.rtageral && permissions.rtageral.allowed == true) {
                this.pagePermissions.isMainResp = true;
                this.pagePermissions.isAuxResp = true;
                this.pagePermissions.isActionReasonResp = true;
                this.pagePermissions.canFinish = true;
                this.pagePermissions.canAvaliate = true;
                this.pagePermissions.canCancel = true;
            }

            this.pagePermissions.isManualRta = this.isManual;
        },

        async loadOriginOptions() {
            try {
                const res = await axios.get(`${urlMainAPI}/getrtaoriginoptions`);
                this.originCustomItems = res.data || [];
            } catch (e) {
                showError(e);
            }
        },

        openOriginManager() {
            this.editingOriginItems = this.originCustomItems.map(i => ({ ...i }));
            this.deletedOriginIds = [];
            this.newOriginValue = "";
            this.originSearchQuery = "";
            this.originPresetsCollapsed = true;
            this.originCustomsCollapsed = true;
            this.$bvModal.show("modalOriginManager");
        },

        addOriginItem() {
            const val = this.newOriginValue.trim();
            if (!val) return;
            this.editingOriginItems.push({ id: 0, value: val, active: 1 });
            this.newOriginValue = "";
        },

        deleteOriginItem(item) {
            if (item.id) this.deletedOriginIds.push(item.id);
            this.editingOriginItems = this.editingOriginItems.filter(i => i !== item);
        },

        async saveOriginDomains() {
            this.savingOrigins = true;
            try {
                const toSave = this.editingOriginItems.filter(i => i.value && i.value.trim());
                if (toSave.length) {
                    await axios.post(`${urlMainAPI}/saveoriginoptions`, toSave);
                }
                for (const id of this.deletedOriginIds) {
                    await axios.post(`${urlMainAPI}/deleteoriginoption/${id}`);
                }
                await this.loadOriginOptions();
                this.$bvModal.hide("modalOriginManager");
                defaultSuccess("Origens salvas com sucesso.");
            } catch (e) {
                showError(e);
            } finally {
                this.savingOrigins = false;
            }
        },
    },
    async mounted() {
        this.loading = true;
        this.loadOriginOptions();

        // Verifica se recebeu apenas o rtaId (id ou código) para buscar do backend
        const rtaIdParam = this.$route.params.rtaId;
        const hasRtaData = this.$route.params.rtaData && this.$route.params.rtaData != undefined;
        const hasStorageData = !!sessionStorage.getItem("currentRTA");
        const shouldFetchFromBackend = rtaIdParam && rtaIdParam !== 'novo' && !hasRtaData && !hasStorageData && !this.isManual;

        if (shouldFetchFromBackend) {
            // Busca os dados da RTA diretamente do backend pelo id ou código
            const rtaLoaded = await this.loadRtaById(rtaIdParam);
            if (!rtaLoaded) {
                showError("Falha ao carregar dados da RTA.");
                this.loading = false;
                return;
            }
        } else if (!hasRtaData) {
            let rtaStorage = sessionStorage.getItem("currentRTA");

            if (this.isManual == true || rtaStorage == undefined) {
                sessionStorage.removeItem("currentRTA");
                this.detailsRta = {
                    id: -9999,
                    code: "",
                    desc: "",
                    creationDate: Date.now(),
                    formattedCreationDate: "",
                    stopNote: "",
                    status: "",
                    indicatorId: null,
                    indicator: "",
                    processId: null,
                    process: "",
                    productId: null,
                    product: "",

                    equipmentId: null,
                    equipment: "",
                    triggerId: "",
                    trigger: "MAN",
                    mainRespId: null,
                    responsible: "",

                    efficiencyRespId: null,
                    efficiencyRespName: "",

                    auxResponsibles: "",
                    generalResponsibles: "",

                    relatedRtaId: null,
                    workshiftId: null,
                    workshift: "",

                    value: 0,
                    target: 0,
                    deadline: Date.now(),
                    formattedDeadline: "",

                    efficiencyrta: "",
                    efficiencyaction: "",

                    relatedfca: 0
                }
                this.deadlineModified = false;
            } else {
                this.detailsRta = { ...JSON.parse(rtaStorage) };
                if (this.detailsRta.mainRespId != null) this.detailsRta.mainRespId = Number(this.detailsRta.mainRespId);
                if (this.detailsRta.efficiencyRespId != null) this.detailsRta.efficiencyRespId = Number(this.detailsRta.efficiencyRespId);
                this.deadlineModified = false;

                // Descrição será gerada depois de carregar allIndicators
                if (this.detailsRta.description != "" && this.detailsRta.description != null && this.detailsRta.description != undefined) {
                    this.detailsRta.desc = this.detailsRta.description;
                }

                // Garante que auxResponsibles use o campo correto vindo da API ou storage
                const incomingAux = this.detailsRta.generalResponsibles ?? this.detailsRta.auxResponsibles;
                this.detailsRta.generalResponsibles = incomingAux;
                this.detailsRta.auxResponsibles = incomingAux;

                // Processa auxResponsibles (já deve vir como array do sessionStorage, mas garante)
                if (typeof this.detailsRta.auxResponsibles === 'string') {
                    const raw = this.detailsRta.auxResponsibles;
                    if (raw === "" || raw === "Não encontrado." || raw === "-") {
                        this.detailsRta.auxResponsibles = [];
                    } else {
                        try { this.detailsRta.auxResponsibles = JSON.parse(raw); }
                        catch (e) { this.detailsRta.auxResponsibles = []; }
                    }
                } else if (!this.detailsRta.auxResponsibles) {
                    this.detailsRta.auxResponsibles = [];
                }

                if (this.detailsRta.statusId == 6 || this.detailsRta.statusId == 7 || this.detailsRta.statusId == 10) this.disableEdit = true;
                this.rtaWasConcluded = [6, 10].includes(this.detailsRta.statusId);
                if ([6, 8, 10].includes(this.detailsRta.statusId)) {
                    this.rtaWasEvaluated = true;
                } else {
                    try {
                        const efficRes = await axios.get(`${urlMainAPI}/getefficiencyrta/${this.detailsRta.id}/rta/${this.detailsRta.id}`);
                        this.rtaWasEvaluated = !!(efficRes.data && efficRes.data.effic);
                    } catch {
                        this.rtaWasEvaluated = false;
                    }
                }
            }
        } else {
            this.detailsRta = this.$route.params.rtaData;
            if (this.detailsRta.mainRespId != null) this.detailsRta.mainRespId = Number(this.detailsRta.mainRespId);
            if (this.detailsRta.efficiencyRespId != null) this.detailsRta.efficiencyRespId = Number(this.detailsRta.efficiencyRespId);

            // Descrição será gerada depois de carregar allIndicators
            if (this.detailsRta.description != "" && this.detailsRta.description != null && this.detailsRta.description != undefined) {
                this.detailsRta.desc = this.detailsRta.description;
            }

            const incomingAux = this.detailsRta.generalResponsibles ?? this.detailsRta.auxResponsibles;
            this.detailsRta.generalResponsibles = incomingAux;
            this.detailsRta.auxResponsibles = incomingAux;

            if (typeof this.detailsRta.auxResponsibles === 'string') {
                const raw = this.detailsRta.auxResponsibles;
                if (raw === "" || raw === "Não encontrado." || raw === "-") {
                    this.detailsRta.auxResponsibles = [];
                } else {
                    try { this.detailsRta.auxResponsibles = JSON.parse(raw); }
                    catch (e) { this.detailsRta.auxResponsibles = []; }
                }
            } else if (!this.detailsRta.auxResponsibles) {
                this.detailsRta.auxResponsibles = [];
            }

            if (this.$route.params.secondaryTriggers && this.$route.params.secondaryTriggers.length > 0) {
                this.secondaryTriggers = this.$route.params.secondaryTriggers.map(trigger => ({
                    ...trigger,
                    triggerId: trigger.id
                }));
            }

            if (this.detailsRta.statusId == 6 || this.detailsRta.statusId == 7) this.disableEdit = true;
            this.rtaWasConcluded = [6, 10].includes(this.detailsRta.statusId);
            if ([6, 8, 10].includes(this.detailsRta.statusId)) {
                this.rtaWasEvaluated = true;
            } else {
                try {
                    const efficRes = await axios.get(`${urlMainAPI}/getefficiencyrta/${this.detailsRta.id}/rta/${this.detailsRta.id}`);
                    this.rtaWasEvaluated = !!(efficRes.data && efficRes.data.effic);
                } catch {
                    this.rtaWasEvaluated = false;
                }
            }

            sessionStorage.setItem("currentRTA", JSON.stringify(this.detailsRta))
        }

        this.changeTableSizes();
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });

        await this.loadRelatedIndicatorId();

        await this.loadUsers();
        await this.loadProductionInfos();

        if (!this.isManual && (this.detailsRta.description == "" || this.detailsRta.description == null || this.detailsRta.description == undefined)) {
            this.detailsRta.desc = this.generateAutomaticDescription(this.detailsRta);
        }

        await this.loadGeneralConfig();

        await this.getDealingReasonActionTables();

        if (this.detailsRta.id != -9999 && !this.secondaryTriggers.length) {
            await this.loadLinkedTriggers();
        }

        this.validatePermissions();

        this.loading = false;
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
}
</script>

<style>

/* ── Origin manager modal ─────────────────────────────────────────────────── */
.sru-input {
  width: 100%;
  border: 1px solid #ff6600;
  border-radius: 3px;
  padding: 3px 6px;
  font-size: 12px;
  box-sizing: border-box;
  transition: box-shadow 0.15s;
}
.sru-input:focus {
  outline: none;
  border-color: #ff6600;
  box-shadow: 0 0 0 3px rgba(255, 102, 0, 0.15);
}
.sru-input:disabled {
  background: #f5f5f5;
  color: #999;
}
.domain-search-row { margin-bottom: 8px; }
.domain-scroll-area { max-height: 340px; overflow-y: auto; margin-bottom: 8px; padding-right: 4px; }
.domain-list { margin-bottom: 8px; }
.domain-list-item { display: flex; align-items: center; gap: 6px; margin-bottom: 4px; }
.domain-input { flex: 1; }
.domain-add-row { display: flex; gap: 6px; margin-bottom: 12px; }
.domain-footer { display: flex; gap: 8px; justify-content: flex-end; }
.accordion-enter-active,
.accordion-leave-active {
  transition: max-height 0.25s ease, opacity 0.25s ease;
  max-height: 600px;
  overflow: hidden;
}
.accordion-enter,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
}
.group-header {
  background: #eee;
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
  border-radius: 4px;
  text-transform: uppercase;
  user-select: none;
}
.group-header:hover { background: #e0e0e0; }
.domain-presets-section { margin-bottom: 8px; }
.domain-list-item--preset .sru-input:disabled { background: #f5f5f5; color: #999; cursor: default; }
.btn-delete-domain { background: transparent; border: none; cursor: pointer; padding: 2px 4px; flex-shrink: 0; color: #e53935; }
.btn-delete-domain:hover { color: #b71c1c; }
.btn-add-domain { padding: 4px 12px; background: #4caf50; color: #fff; border: none; border-radius: 4px; cursor: pointer; font-size: 16px; font-weight: bold; }
.btn-save-domain { height: 33px; padding: 6px 16px; background: #ff6600; color: #fff; border: none; border-radius: 4px; cursor: pointer; font-weight: 600; }
.btn-cancel-domain { height: 33px; padding: 6px 16px; background: #fff; color: #666; border: 1px solid #ccc; border-radius: 4px; cursor: pointer; }
/* ─────────────────────────────────────────────────────────────────────────── */

.customTabsClassContainerRta {
    border-width: 0 1px 1px 1px;
    border-color: #dee2e6;
    border-style: solid;
    border-radius: 0.1rem;
    padding: 0.5rem;
}

.customTabsClassRta li {
    color: #008787;
}

.customTabsClassRta li a {
    border-color: #DCDCDC !important;

    background-color: #F2F2F2 !important;
    color: #969B9B !important;
}

.customTabsClassRta li a[aria-selected="true"] {
    color: #00A39F !important;
    background-color: #fff !important;
}

.showDetailsBtn {
    width: 100%;
    font-weight: 500;
    font-size: 0.8rem;
    border: none;
    background-color: transparent;
    color: #c2c2c2;
    padding: 0;
    margin-top: 2rem;

    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 0.2rem;
    white-space: nowrap;
}

.showDetailsBtn::before,
.showDetailsBtn::after {
    content: "";
    display: block;
    height: 1px;
    width: 80%;
    background-color: #c2c2c2;
}

.customTabsReasonContainer li {
    padding: 0;
    margin: 0.3rem 0.4rem;
    text-align: center;
}

.customTabsReasonContainer li a {
    border: 1px solid #949494;
    border-radius: 0.3rem;
    background-color: #ffffff !important;
    color: #909090;
    padding: 0.2rem 0.3rem !important;
}

.customTabsReasonContainer li a[aria-selected="true"] {
    border-color: #046FDB !important;
    color: #046FDB !important;
    background-color: #fff !important;
}
</style>

<style scoped>
.rtaTitle {
    padding-bottom: 0.3rem;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    column-gap: 0.3rem;
    border-bottom: 1px solid #c7c7c7;
}

.rtaTitle img {
    height: 30px;
}

.rtaTitle span {
    font-weight: 600;
    font-size: 1.3rem;
}

.btn-back {
    background-color: transparent;
    color: #000;
    border: none;
    padding: 0.2rem 0;
    margin-right: 5px;
    margin-left: 5px;
    font-size: 1rem;
    font-weight: 400;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    text-decoration: none;
    transition: opacity 0.2s ease;
}

.btn-back:hover {
    opacity: 0.6;
}

.btn-back i {
    font-size: 1rem;
}

.rtaDetailsContainer {
    /* display: grid;
    grid-template-rows: 6rem 3rem max-content max-content;
    row-gap: 0.5rem;
    height: max-content; */

    padding: 0.3rem 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    row-gap: 0.2rem;
}

.respContainer {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 0.8rem;
    padding-top: 0.5rem;
    align-items: end;
}

.openFcas {
    margin-top: 5px;
    display: flex;
    column-gap: 0.5rem;
    max-height: 2.5rem;
}

.openFcas .buttons-container {
    display: flex;
    flex-direction: column;
    row-gap: 0.3rem;
}

.openFcas button {
    background-color: #FF5F00;
    color: #fff;
    border: 1px solid #FF5F00;
    border-radius: 0.2rem;
    font-weight: 600;
    font-size: 0.8rem;
    white-space: nowrap;
    padding: 9px 0.6rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-view-linked-fcas:hover {
    background-color: #e55500;
    border-color: #e55500;
}

.addLineTable {
    width: 100%;
    background-color: #91E5E5;
    color: #008787;
    text-align: center;
    border: none;
    padding: 0.2rem;
    border-radius: 0.2rem;
    margin-top: 0.4rem;
}

.addLineTable span {
    margin-left: 0.3rem;
}

.rtaBtnContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.rtaBtnContainer div {
    display: flex;
    align-items: center;
    column-gap: 0.5rem;
}

.rtaBtnContainer button {
    border: 1px solid #000;
    border-radius: 0.2rem;
    font-weight: 500;
    background-color: #fff;
    padding: 0.3rem 0.4rem;
    display: flex;
    align-items: center;
    column-gap: 0.3rem;
}

.rtaBtnContainer .cancelBtn {
    color: #D21724;
    border-color: #D21724;
}

.rtaBtnContainer .accBtn {
    color: #008787;
    border-color: #008787;
}

.rtaBtnContainer .doneBtn {
    color: #FF7122;
    border-color: #FF7122;
}

.rtaBtnContainer .saveBtn {
    color: #fff;
    border-color: #FF7122;
    background-color: #FF7122;
}

.rtaBtnContainer .reopenBtn {
    color: #fff;
    border-color: #008787;
    background-color: #008787;
}

.attachment-btn-container {
    display: inline-flex;
    align-items: center;
}

.heightContainer {
    height: 100%;
}

.methodsAllowed {
    width: 100%;
}

.generalInfo {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 0.5rem;
    grid-row-gap: 0.5rem;
}

.code {
    grid-area: 1 / 1 / 2 / 2;
}

.ind {
    grid-area: 1 / 3 / 2 / 4;
}

.proc {
    grid-area: 1 / 2 / 2 / 3;
}

.prod {
    grid-area: 1 / 4 / 2 / 5;
}

.resp {
    grid-area: 1 / 5 / 2 / 6;
}

.auxResp {
    grid-area: 1 / 6 / 3 / 8;
    position: relative;
    border: 1px solid #C7C7C7;
    border-radius: 0.2rem;
}

.auxResp span {
    position: absolute;
    padding: 0.2rem;
    background-color: white;
    color: #FF5F00;
    font-size: 0.8rem;

    top: -.8rem;
    left: 0.4rem;
}

.participants-list {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    row-gap: 0.3rem;
    max-height: 6rem;
    overflow-y: auto;
    margin-top: 0.8rem;
}

.participants-list p {
    margin: 0;
    padding: 0.1rem;
    font-size: 0.9rem;
    color: #272727;
    background-color: #f3f3f3;
    border-radius: 0.2rem;
}

.btn-add-participant {
    position: absolute;
    top: -0.65rem;
    right: 0.4rem;
    background-color: #00A39F;
    color: white;
    border: none;
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 0.7rem;
}

.btn-add-participant:hover {
    background-color: #008787;
    transform: scale(1.1);
}

.participant-item {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    justify-content: space-between;
    padding: 0.3rem 0.5rem;
    background-color: #f3f3f3;
    border-radius: 0.2rem;
    margin-bottom: 0.3rem;
}

.participant-item p {
    margin: 0 !important;
    padding: 0 !important;
    background-color: transparent !important;
    flex: 1;
}

.btn-remove-participant {
    background-color: transparent;
    color: #D21724;
    border: none;
    padding: 0.2rem;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 0.9rem;
}

.btn-remove-participant:hover {
    color: #a01219;
    transform: scale(1.2);
}

.creation {
    grid-area: 2 / 1 / 3 / 2;
}

.stopNote {
    grid-area: 3 / 1 / 4 / 2;
}

.deadline {
    grid-area: 2 / 2 / 3 / 3;
}

.equip {
    grid-area: 2 / 3 / 3 / 4;
}

.trigger {
    grid-area: 2 / 4 / 3 / 5;
}

.accResp {
    grid-area: 2 / 5 / 3 / 6;
}

/* Forçar selects neutros nesta tela (sem laranja) */
::v-deep .select-shell {
    border-color: #C7C7C7 !important;
    box-shadow: none !important;
}

::v-deep .select-shell:focus-within {
    box-shadow: none !important;
}

/* Remover bordas internas de inputs select/input/spinbutton nesta tela */
::v-deep input.select-value,
::v-deep input.input-pentagro,
::v-deep select.input-pentagro,
::v-deep div.spinbutton-pentagro,
::v-deep #app select,
::v-deep #app input {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
}

/* Mantém selects com borda neutra nesta tela */
.select-shell {
    border-color: #C7C7C7 !important;
    box-shadow: none !important;
}

.select-shell:focus-within {
    box-shadow: none !important;
}

/* Estilos do Modal de Adicionar Participantes */
.add-participant-content {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    padding: 0.5rem 0;
}

.btn-add-to-list {
    background-color: #00A39F;
    color: white;
    border: none;
    border-radius: 0.3rem;
    padding: 0.5rem 1rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.5rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-add-to-list:hover:not(:disabled) {
    background-color: #008787;
}

.btn-add-to-list:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.temp-participants-list {
    border: 1px solid #dee2e6;
    border-radius: 0.3rem;
    padding: 0.8rem;
}

.temp-participants-list h6 {
    font-size: 0.9rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #008787;
}

.temp-participant-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4rem 0.6rem;
    background-color: #f8f9fa;
    border-radius: 0.2rem;
    margin-bottom: 0.3rem;
}

.temp-participant-item span {
    font-size: 0.9rem;
    color: #272727;
}

.btn-remove-temp {
    background-color: transparent;
    color: #D21724;
    border: none;
    padding: 0.2rem;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 0.9rem;
}

.btn-remove-temp:hover {
    color: #a01219;
    transform: scale(1.2);
}

.modal-footer-custom {
    display: flex;
    justify-content: flex-end;
    column-gap: 0.5rem;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #dee2e6;
}

.btn-cancel-modal {
    background-color: #fff;
    color: #6c757d;
    border: 1px solid #6c757d;
    border-radius: 0.3rem;
    padding: 0.4rem 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-cancel-modal:hover {
    background-color: #6c757d;
    color: white;
}

.btn-confirm-modal {
    background-color: #FF7122;
    color: white;
    border: 1px solid #FF7122;
    border-radius: 0.3rem;
    padding: 0.4rem 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-confirm-modal:hover:not(:disabled) {
    background-color: #e55f0f;
}

.btn-confirm-modal:disabled {
    background-color: #ccc;
    border-color: #ccc;
    cursor: not-allowed;
}


.secondary-triggers-table {
    font-size: 0.85rem;
}

::v-deep(.secondary-triggers-table thead th) {
    background-color: #004747;
    color: #fff;
    font-weight: 600;
    border: none;
    padding: 0.5rem;
}

.secondary-triggers-table tbody td {
    padding: 0.4rem;
    vertical-align: middle;
}

.secondary-triggers-table tbody tr:hover {
    background-color: #f0f8f8;
}

.LinkedTriggersButton{
    height: 50px;
}

.warning-text {
    color: #dc3545;
    font-weight: 500;
    margin-top: 0.5rem;
}

.modal-buttons-spread {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    padding-top: 0.5rem;
    border-top: 1px solid rgb(196, 196, 196);
}

.modal-buttons-spread .cancel-btn {
    padding: 0.5rem 1rem;
    font-weight: 500;
    color: white;
    background-color: gray;
    border: none;
    border-radius: 0.2rem;
    cursor: pointer;
}

.modal-buttons-spread .confirm-btn {
    padding: 0.5rem 1rem;
    font-weight: 500;
    color: white;
    background-color: #ff5f00;
    border: none;
    border-radius: 0.2rem;
    cursor: pointer;
}
</style>
